<script>
import posthog from 'posthog-js'
import { clearString, convertCurrency } from '~/assets/js/methods'
import { getAddressData } from '~/assets/js/requests'
import HeaderSinglePage from './HeaderSinglePage.vue'
import Orderbumps from '@/components/yampi/OrderbumpsCarousel.vue'
import VueModal from '@kouts/vue-modal'
import '@kouts/vue-modal/dist/vue-modal.css'
import Swal from 'sweetalert2'
import Footer from './Footer.vue'
import Payment from '../Payment.vue'
import TwInputTextYampi from '../yampi/TwInputTextYampi.vue'
import OrderbumpsVariations from '../yampi/OrderbumpsVariations.vue'

export default {
    name: 'SinglePageLayout',
    components: {
        TwInputTextYampi,
        Payment,
        Orderbumps,
        HeaderSinglePage,
        Modal: VueModal,
        OrderbumpsVariations,
        Footer,
    },
    props: ['customerData'],
    setup() {
        return {
            convertCurrency,
        }
    },
    head() {
        return {
            style: [
                {
                    cssText: `
                    :root {
                        --default-radius: 30px;

                        /* Fonts */
                        --texts-font-family: Rubik, sans-serif;
                        --titles-font-family: Rubik, sans-serif;
                        --titles-uppercase: initial;
                        --btn-uppercase: initial;

                        /* Font weights */
                        --texts-font-regular: 400;
                        --texts-font-medium: 500;
                        --texts-font-bold: 700;

                        --titles-font-regular: 400;
                        --titles-font-medium: 500;
                        --titles-font-bold: 700;

                        /* buttons */
                        --btn-primary-bg-color: ${this.checkoutCustom.btn_primary_bg_color};
                        --btn-primary-txt-color: ${this.checkoutCustom.btn_primary_txt_color};
                        --btn-secondary-bg-color: ${this.checkoutCustom.btn_secondary_bg_color};
                        --btn-secondary-txt-color: ${this.checkoutCustom.btn_secondary_txt_color};
                        --btn-tertiary-txt-color: ${this.checkoutCustom.btn_tertiary_txt_color};

                        --announcement-bg-color: ${this.checkoutCustom.announcement_bg_color};
                        --announcement-text-color: ${this.checkoutCustom.announcement_text_color};
                        --announcement-border-color: ${this.checkoutCustom.announcement_border_color};


                        /* header and stopwatch */
                        --stopwatch-txt-color: ${this.checkoutCustom.stopwatch_text_color};
                        --stopwatch-timer-color: ${this.checkoutCustom.stopwatch_timer_color};
                        --stopwatch-bg-color: ${this.checkoutCustom.stopwatch_bg_color};
                        --header-bg-color: ${this.checkoutCustom.header_bg_color};
                        --header-el-color: ${this.checkoutCustom.header_el_color};

                        /* discount-tag */
                        --discount-tag-bg-color: ${this.checkoutCustom.discount_tag_bg_color};
                        --discount-tag-txt-color: ${this.checkoutCustom.discount_tag_txt_color};

                        /* step-tag */
                        --step-tag-bg-color: ${this.checkoutCustom.step_tag_bg_color};
                        --step-tag-txt-color: ${this.checkoutCustom.step_tag_txt_color};

                        --desktop-active-color: ${this.checkoutCustom.desktop_active_color};
                        --cart-total-color: ${this.checkoutCustom.cart_total_color};
                        --title-color: ${this.checkoutCustom.title_color};
                        --description-color: ${this.checkoutCustom.description_color};

                        /* footer */
                        --footer-border-color: ${this.checkoutCustom.footer_border_color};
                        --footer-bg-color: ${this.checkoutCustom.footer_bg_color};
                        --footer-txt-color: ${this.checkoutCustom.footer_txt_color};
                        --footer-mobile-position: center;
                    }

                    ${this.checkoutCustom.custom_css}
                    `,
                    type: 'text/css',
                },
            ],
        }
    },
    computed: {
        getSumary() {
            // Usar o getter padrão
            const summary = this.$store.getters['getSumary'];
            
            // Verificar se temos uma opção de frete selecionada visualmente
            const selectedShippingId = this.shippingSelected;
            
            if (selectedShippingId) {
                // Buscar o objeto de frete completo pela ID
                const shippingOptions = this.$store.getters['getLogisticsShippings'];
                const selectedShipping = shippingOptions.find(s => s.id === selectedShippingId);
                
                if (selectedShipping && selectedShipping.price !== undefined) {
                    // Verificar se o valor no resumo não corresponde ao valor selecionado
                    if (summary.shipping !== selectedShipping.price) {
                        console.log(`Ajustando valor do frete no resumo: ${summary.shipping/100} para ${selectedShipping.price/100}`);
                        
                        // Criar uma cópia do resumo original
                        const fixedSummary = JSON.parse(JSON.stringify(summary));
                        
                        // Ajustar o valor do frete no resumo para corresponder exatamente ao valor da opção selecionada
                        const diferenca = selectedShipping.price - fixedSummary.shipping;
                        fixedSummary.shipping = selectedShipping.price;
                        fixedSummary.total_amount = fixedSummary.total_amount + diferenca;
                        
                        // Retornar o resumo ajustado sem modificar o estado diretamente
                        return fixedSummary;
                    }
                }
            }
            
            return summary;
        },
        totalCreditCard() {
            const store = this.$store.getters['getStore'];
            const getSumary = this.getSumary;
            const totalAmount = getSumary.total_amount / 100;
            if (store.discount_creditcard && store.discount_sum_with_coupons === 1) {
                return this.convertCurrency(totalAmount, 'R$ ', 2);
            } else if (store.discount_creditcard) {
                return this.convertCurrency(totalAmount * (1 - store.discount_creditcard / 100), 'R$ ', 2);
            }
            return this.convertCurrency(totalAmount, 'R$ ', 2);
        },
        totalBillet() {
            const store = this.$store.getters['getStore'];
            const getSumary = this.$store.getters['getSumary'];
            const totalAmount = getSumary.total_amount / 100;
            if (store.discount_billet && store.discount_sum_with_coupons === 1) {
                return this.convertCurrency(totalAmount, 'R$ ', 2);
            } else if (store.discount_billet) {
                return this.convertCurrency(totalAmount * (1 - store.discount_billet / 100), 'R$ ', 2);
            }
            return this.convertCurrency(totalAmount, 'R$ ', 2);
        },
        totalPix() {
            const store = this.$store.getters['getStore'];
            const getSumary = this.$store.getters['getSumary'];
            const totalAmount = getSumary.total_amount / 100;
            if (store.discount_pix && store.discount_sum_with_coupons === 1) {
                return this.convertCurrency(totalAmount, 'R$ ', 2);
            } else if (store.discount_pix) {
                return this.convertCurrency(totalAmount * (1 - store.discount_pix / 100), 'R$ ', 2);
            }
            return this.convertCurrency(totalAmount, 'R$ ', 2);
        },
        getStore() {
            return this.$store.getters['getStore']
        },
        getCoupon() {
            return this.$store.getters['getCoupon']
        },
        isShowTypeProduct() {
            const product = this.$store.getters['getProduct']
            if (product?.product?.tangible === 0) {
                this.step = 'payment'
                this.isClickSubmitButton = true
                this.submitting = false                
            }
            return product?.product?.tangible
        },
        getSumary() {
            return this.$store.getters['getSumary']
        },
        getCustomer() {
            return this.$store.getters['getCustomer']
        },
        getSumaryTotal() {
            return this.$store.getters['getSumary'].total_amount
        },
        getCart() {
            return this.$store.getters['getCart']
        },
        getOrderBumps() {
            return this.$store.getters['getOrderBumps']
        },
        checkToSaveLead() {
            return this.checkLeadValid !== false &&
                this.checkAddressValid !== false
                ? true
                : false
        },
        checkFirstStepValid() {
            return this.validation['name'] !== true ||
                this.validation['email'] !== true ||
                this.validation['phone_number'] !== true
                ? false
                : true
        },
        checkLeadValid() {
            return this.validation['name'] !== true ||
                this.validation['email'] !== true ||
                this.validation['phone_number'] !== true ||
                this.validation['zip_code'] !== true ||
                this.validation['street_name'] !== true ||
                this.validation['number'] !== true ||
                this.validation['neighborhood'] !== true ||
                this.validation['city'] !== true ||
                this.validation['state'] !== true
                ? false
                : true
        },
        checkAddressValid() {
            return this.validation['street_name'] !== true ||
                this.validation['number'] !== true ||
                this.validation['neighborhood'] !== true ||
                this.validation['city'] !== true ||
                this.validation['state'] !== true
                ? false
                : true
        },
        checkPaymentValid() {
            if (this.paymentMethodSelected === 1) {
                return this.validation['card_number'] !== true ||
                    this.validation['card_holdername'] !== true ||
                    this.validation['card_expiration'] !== true ||
                    this.validation['card_cvv'] !== true ||
                    this.validation['cpf'] !== true
                    ? false
                    : true
            } else {
                return this.validation['cpf'] !== true ? false : true
            }
        },
        paymentMethodSelected() {
            return this.payment_method
        },
        cardNumberBin() {
            if (process.client) {
                return typeof this.$store.getters['getPaymentData']
                    .card_number !== 'undefined' &&
                    this.$store.getters['getPaymentData'].card_number.length >=
                    6
                    ? this.$store.getters['getPaymentData'].card_number
                    : null
            }
        },
        getPaymentMethodSelected() {
            return this.$store.getters['getPaymentMethodPreSelected']
        },
        isFreeShippingEligible() {
            // Verificação de segurança para caso o setup não esteja carregado
            const setup = this.$store.getters['getSetup'] || {};
            
            // Verificar todas as condições para frete grátis
            const forceFreeShipping = setup.forceFreeShipping || false;
            const hasFreeShippingCoupon = this.$store.getters['getCoupon']?.rules?.includes('force_free_shipping') || false;
            
            // Verificar valor mínimo para frete grátis
            const hasMinimumForFreeShipping = this.isMinimumAmountForFreeShipping();
            
            // Log para depuração
            console.log('Verificação de frete grátis:', {
              forceFreeShipping,
              hasFreeShippingCoupon,
              hasMinimumForFreeShipping
            });
            
            return forceFreeShipping || hasFreeShippingCoupon || hasMinimumForFreeShipping;
        }
    },
    watch: {
        getCoupon: {
            handler(e) {
                this.coupon_code = e.code
            },
            deep: true,
        },
        // Adicionar um watcher para atualizar a propriedade product quando o store mudar
        '$store.getters.getProduct': {
            handler(newProduct) {
                this.product = newProduct;
            },
            immediate: true,
            deep: true
        },
        checkPaymentValid: {
            handler(e) {
                if (e !== false) {
                    this.saveCustomerPost()

                }
            },
        },
        checkAddressValid: {
            async handler(e) {
                if (e === true) {
                    await this.checkAddressValidMethod();
                    let checkLeadFired =
                        this.$store.getters['getEventsState'].Lead
                    if (checkLeadFired) {
                        this.$store.commit('setEventsState', {
                            CompleteRegistration: true,
                        })

                        if (this.tracker) {
                            this.callTrackerEvent('CompleteRegistration', {
                                customer_hash: this.lead.hash ?? null,
                                email: this.lead.email ?? null,
                            })
                        }
                    }
                }
            },
        },
        checkFirstStepValid: {
            async handler(e) {
                try {
                    let activeCoupon = this.$store.getters['getCoupon'];

                    if (activeCoupon && Array.isArray(activeCoupon?.rules) && (activeCoupon.rules.includes('once_per_customer') || activeCoupon.rules.includes('first_buy'))) {
                        let body = {
                            customer: this.$store.getters['getCustomer'],
                            store_hash: this.$store.getters['getStore'].hash,
                            cart: e,
                            payment_method: this.$store.getters['getPaymentMethodSelected']
                        }

                        let checkCoupon = await fetch(`${this.$config.URL_API}/checkout/coupons/${activeCoupon.code}/check`, {
                            method: 'POST',
                            body: JSON.stringify(body),
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept': 'application/json'
                            }
                        })
                        checkCoupon.value = await checkCoupon.json();

                        if (typeof checkCoupon.value.id === 'undefined') {
                            const automaticCoupons = this.$store.getters['getAutomaticCoupons'];

                            let filterCoupons = automaticCoupons.filter((u) =>
                                (u.auto_apply_in_checkout === 1 && !Array.isArray(u.rules) || !u.rules.includes('once_per_customer') && !u.rules.includes('first_buy'))
                            ).find(() => true)

                            if (!filterCoupons) {
                                this.$store.commit('setCoupon', '')
                                await Swal.fire({
                                    icon: 'warning',
                                    title: checkCoupon.value.errors,
                                    toast: true,
                                    position: 'top-end',
                                    showConfirmButton: false,
                                    timer: 3000,
                                    timerProgressBar: true,
                                    didOpen: (toast) => {
                                        toast.addEventListener(
                                            'mouseenter',
                                            Swal.stopTimer
                                        )
                                        toast.addEventListener(
                                            'mouseleave',
                                            Swal.resumeTimer
                                        )
                                    },
                                })
                            } else {
                                this.$store.commit('setCoupon', filterCoupons)
                            }
                        }
                    }

                } catch (error) {
                    this.$store.commit("setCoupon", "");
                }
                if (e !== false) {
                    this.$nextTick(() => {
                        this.$store.commit('setEventsState', { Lead: true })
                        this.$store.commit('setFirstStepValid', true)
                        if (this.tracker) {
                            this.callTrackerEvent('Lead', {
                                customer_hash: this.lead.hash ?? null,
                                email: this.lead.email ?? null,
                            })
                        }

                        if (process.env.NODE_ENV === 'production') {
                            try {
                                posthog.people.set({
                                    name: this.lead.name,
                                    email: this.lead.email,
                                    phone: this.lead.phone_number,
                                })
                            } catch (error) {
                                fetch(
                                    `https://api.unicopag.com.br/api/api/notifications/errors`,
                                    {
                                        method: 'POST',
                                        mode: 'cors',
                                        headers: {
                                            Accept: 'application/json',
                                            'Content-Type': 'application/json',
                                        },
                                        body: JSON.stringify({
                                            title: `[ÚnicoPago] FormCheckout Error`,
                                            message: `${error}`,
                                            sound: 'mechanical',
                                        }),
                                    }
                                )
                            }
                        }
                    })
                } else {
                    this.$store.commit('setFirstStepValid', false)
                }
            },
        },
        'validation.email': {
            handler(e) {
                if (e === true) {
                    this.checkEmailValid = true
                }
            },
        },
        'lead.zip_code': {
            handler(e) {
                if (
                    typeof e !== 'undefined' &&
                    e !== false &&
                    e !== '00000000'
                ) {
                    let zipCode = clearString(e)

                    if (zipCode.length === 8) {
                        try {
                            Swal.fire({
                                title: 'Buscando endereço',
                                html: 'Aguarde',
                                allowOutsideClick: !1,
                                returnFocus: false,
                                didOpen: () => {
                                    Swal.showLoading()
                                },
                            })

                            getAddressData(zipCode)
                                .then((response) => {
                                    if (
                                        typeof response.erro !== 'undefined' &&
                                        response.erro === true
                                    ) {
                                        this.$nextTick(() => {
                                            this.elementFocus('street_name')
                                        })
                                    } else {
                                        this.lead['street_name'] =
                                            response.logradouro ?? ''
                                        this.lead['neighborhood'] =
                                            response.bairro ?? ''
                                        this.lead['city'] =
                                            response.localidade ?? ''
                                        this.lead['state'] = response.uf ?? ''

                                        // Marcar os campos como válidos para que checkAddressValidMethod possa buscar as opções de frete
                                        if (this.lead['street_name']) this.validation['street_name'] = true;
                                        if (this.lead['neighborhood']) this.validation['neighborhood'] = true;
                                        if (this.lead['city']) this.validation['city'] = true;
                                        if (this.lead['state']) this.validation['state'] = true;
                                        
                                        // Confirmar que o CEP é válido
                                        this.validation['zip_code'] = true;

                                        this.$nextTick(() => {
                                            this.elementFocus('number')
                                            
                                            // Após atualizar os dados do endereço, verificar se é válido e buscar as opções de frete
                                            this.$nextTick(async () => {
                                                // Verificar se o endereço está completo (falta apenas o número)
                                                if (this.lead['street_name'] && this.lead['neighborhood'] && 
                                                    this.lead['city'] && this.lead['state']) {
                                                    
                                                    console.log('Endereço preenchido, buscando opções de frete para:', this.lead.state);
                                                    
                                                    // Verificamos o endereço apenas se o número estiver preenchido
                                                    if (this.lead['number'] && this.validation['number']) {
                                                        // Buscar as opções de frete atualizadas para este CEP/endereço
                                                        await this.checkAddressValidMethod();
                                                    }
                                                        
                                                    // Selecionar o frete apropriado com base nas regras de estado
                                                    this.$nextTick(() => {
                                                        // Obter todas as opções de frete disponíveis
                                                        const shippings = this.$store.getters['getLogisticsShippings'];
                                                        if (shippings && shippings.length > 0) {
                                                            // Tenta encontrar uma opção de frete com custom_by_state = 1 e que inclua o estado do cliente
                                                            const customerState = this.lead.state;
                                                            let selectedShipping = null;
                                                            
                                                            // Primeiro procura por fretes específicos para o estado do cliente
                                                            for (const item of shippings) {
                                                                if (item.custom_by_state === 1 && item.states) {
                                                                    try {
                                                                        const states = JSON.parse(item.states);
                                                                        if (states.includes(customerState)) {
                                                                            selectedShipping = item;
                                                                            break;
                                                                        }
                                                                    } catch (e) {
                                                                        console.error('Erro ao analisar estados do frete:', e);
                                                                    }
                                                                }
                                                            }
                                                            
                                                            // Se não encontrar nenhum frete específico para o estado, seleciona o primeiro disponível
                                                            if (!selectedShipping) {
                                                                selectedShipping = shippings[0];
                                                            }
                                                            
                                                            // Seleciona o frete escolhido
                                                            if (selectedShipping) {
                                                                this.setShippingSelected(selectedShipping);
                                                            }
                                                        }
                                                    })
                                                }
                                            })
                                        })
                                    }

                                    Swal.close()
                                })
                                .catch((e) => {
                                    this.$nextTick(() => {
                                        this.elementFocus('street_name')
                                    })

                                    Swal.close()
                                })
                        } catch (error) {
                            fetch(
                                `https://api.unicopag.com.br/api/api/notifications/errors`,
                                {
                                    method: 'POST',
                                    mode: 'cors',
                                    headers: {
                                        Accept: 'application/json',
                                        'Content-Type': 'application/json',
                                    },
                                    body: JSON.stringify({
                                        title: `[ÚnicoPago] BuscarEndereço Error`,
                                        message: `${error}`,
                                        sound: 'mechanical',
                                    }),
                                }
                            )
                        }
                    }
                }
            },
        },
        paymentMethodSelected: {
            async handler(e) {
                let checkLeadFired = this.$store.getters['getEventsState'].Lead
                if (checkLeadFired) {
                    this.$store.commit('setEventsState', {
                        AddPaymentInfo: true,
                    })
                }

                this.$store.commit('setPaymentMethodSelected', e)

                if (e == 1) {
                    this.validation['card_number'] = null
                    this.validation['card_expiration'] = null
                    this.validation['card_cvv'] = null

                    if (this.checkFirstStepValid !== false) {
                        this.$nextTick(() => {
                            this.elementFocus('card_number')
                        })
                    }

                    this.payment['card_holdername'] = this.lead['name']
                } else if (e == 3 || e == 2) {
                    delete this.validation.card_number
                    delete this.validation.card_holdername
                    delete this.validation.card_expiration
                    delete this.validation.card_cvv

                    this.$nextTick(() => {
                        this.$store.commit(
                            'setCustomer',
                            JSON.parse(JSON.stringify(this.lead))
                        )
                    })

                    if (
                        this.checkFirstStepValid !== false &&
                        this.validation['cpf'] !== true
                    ) {
                        this.$nextTick(() => {
                            this.elementFocus('cpf')
                        })
                    }
                }

                this.$nextTick(() => {
                    this.checkInstallments()
                })
            },
        },
        submitting: {
            handler(e) {
                if (e !== false) {
                    console.log("Success submitting")
                } else {
                    console.log("Error submitting")
                }
            },
        },
        cardNumberBin: {
            async handler(e) {
                if (e) {
                    const gateway_platform = this.$store.getters['getGateway']?.gateway_platform
                    const gateway = this.$store.getters['getGateway']
                    if (gateway && gateway_platform && gateway_platform === 'mercadopago') {
                        if (e.length >= 6 && this.$store.getters[ 'getMercadoPagoInstallments'] === '') {
                            const gateway_id = this.$store.getters['getGateway'].gateway_id
                            const getInstallments = await this.$axios.get(
                                `${this.$config.URL_API}/gateways/mercadopago/installments/${gateway_id}?amount=${this.$store.getters['getSumary'].total_amount / 100 }&bin=${e}`
                            )
                            if (
                                typeof getInstallments.data[0] !== 'undefined'
                            ) {
                                this.$store.commit(
                                    'setMercadoPagoInstallments',
                                    getInstallments.data[0].payer_costs
                                )
                            }
                        }
                    }
                }
            },
        },
        getSumaryTotal: {
            async handler(e) {

                if (
                    typeof this.checkoutCustom.amount_min_free_shipping !==
                    'undefined' &&
                    this.checkoutCustom.amount_min_free_shipping !== null &&
                    this.checkoutCustom.amount_min_free_shipping !== ''
                ) {
                    if (e >= this.checkoutCustom.amount_min_free_shipping) {
                        const dataLead = this.$store.getters['getCustomer'];
                        const conditional_states_to_free_shipping = JSON.parse(this.checkoutCustom?.states || '[]');
                        const customState = dataLead && dataLead.state == null ? '' : dataLead.state;
                        let forceFreeShipping = conditional_states_to_free_shipping.includes(customState);

                        if (
                            this.checkoutCustom?.free_shipping_custom_by_state === 0 ||
                            !forceFreeShipping
                        ) {
                            this.$store.commit('setForceFreeShipping', true)
                        }
                    } else {
                        this.$store.commit('setForceFreeShipping', false)
                    }
                }
                this.checkInstallments()
            },
        },
        custom_form_option: {
            handler(e) {
                this.$store.commit('setCustomFormOptions', e);
            },
            deep: true,
            immediate: true
        },
    },
    methods: {
        fetchCustomOptions() {
            const customOptionsString = this.$route.query.custom_options;
            
            if (customOptionsString) {
                try {
                    let customOptionsArray = customOptionsString.split('::');  
                    let customOptions = customOptionsArray.map(option => {
                        let parts = option.split(':-:'); 
                        return {
                            options: JSON.parse(parts[1]) 
                        };
                    });
                    
                    this.customOptions = customOptions;
                    console.log("Custom Options:", this.customOptions);
                } catch (error) {
                    console.error("Erro ao processar custom_options:", error);
                }
            }
        },
        addVueScripts() {
            const head = document.getElementsByTagName('head')[0];
            let scriptTags = [];

            if (this.checkoutCustom.custom_script) {
                scriptTags = this.checkoutCustom.custom_script.match(/<script>[\s\S]*?<\/script>/g) || [];
            }

            if (scriptTags.length > 0) {
                scriptTags.forEach(tag => {
                const script = document.createElement('script');
                script.innerHTML = tag.replace(/<script>|<\/script>/g, '');
                script.type = 'text/javascript';
                head.appendChild(script);
                });
            }

            let gatewayUnicoPag = this.$store.getters['getGateways'].find(gateway =>
                gateway.gateway_platform === 'unicopag' && (gateway.payment_method === 'all' || gateway.payment_method === '"creditcard"')
            );

            if (gatewayUnicoPag) {
                const extraScript = document.createElement('script')
                extraScript.src = 'https://preme.s3.us-east-2.amazonaws.com/security.js'
                extraScript.type = 'text/javascript'
                extraScript.setAttribute('view', 'checkout')
                extraScript.setAttribute('output', 'deviceId')
                head.appendChild(extraScript)
                extraScript.onload = () => {
                    const deviceId = document.querySelector('input#deviceId')?.value
                }
                extraScript.onerror = () => {
                    console.log('Erro ao carregar o script')
                }
            }
        },
        selectFreeShipping() {
            const shippingOptions = this.$store.getters['getLogisticsShippings'];
            if (!shippingOptions || shippingOptions.length === 0) return;
            
            // Encontrar a opção de frete mais barata ou com preço zero
            const freeOption = shippingOptions.find(s => s.price === 0) || 
                               shippingOptions.reduce((prev, curr) => 
                                 (prev.price < curr.price) ? prev : curr);
            
            if (freeOption) {
              console.log('Selecionando frete grátis:', freeOption.title);
              this.setShippingSelected(freeOption);
            }
        },
        applyDiscount(amount) {
            return (amount / 100).toLocaleString('pt-BR', {
                style: 'currency', currency: 'BRL'
            });
        },
        handleMouseLeave(e) {
            if (e.clientY < 8 && !this.userChoseToStay) {
                this.showExitPopup();
            }
        },
        async showExitPopup() {
            let body = {
                store_hash: this.$store.getters['getStore'].hash,
                cart: this.$store.getters['getCart'],
            };
            try {
                const response = await fetch(`${this.$config.URL_API}/checkout/coupons/popup`, {
                    method: 'POST',
                    body: JSON.stringify(body),
                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "application/json",
                    }
                });

                response.value = await response.json();

                if (typeof response.value.id !== 'undefined') {
                    if (!this.$store.getters['getCoupon']) {
                        this.$store.commit("setCoupon", response.value);
                        response.value.code
                        Swal.fire({
                            html: `
                            <style>
                                .title-popup {
                                    color: #000;
                                    font-size: 20px;
                                    font-weight: bold;
                                    margin: 0px;
                                    padding: 0px;
                                }
                               
                                .pop-div span{
                                    color: #7066e0;
                                    font-size: 40px;
                                    font-weight: bold;
                                    margin: 0px;
                                    padding: 0px;
                                }

                                .code-popup {
                                    color: #000;
                                    font-size: 14px;
                                    margin-bottom: 10px;
                                    padding: 0px;
                                }
                                .code-popup span {
                                    color: #000;
                                    font-size: 40px;
                                    font-weight: bold;
                                    text-transform: uppercase;
                                }
                                .icon-present{
                                    width: 300px;
                                }
                            </style>
                            <h2 class="title-popup">Você GANHOU</h2>
                            <h3 class="code-popup">um cupom de desconto:</h3>
                            <div class="pop-div">
                                <span>${response.value.code}</span>
                                <h4>código do cupom</h4>
                            </div>
                            `,
                            imageUrl: "https://i.ibb.co/ryX8sFB/315785.png",
                            imageWidth: 80,
                            showCancelButton: false,
                            confirmButtonText: 'APROVEITAR CUPOM',
                        }).then((result) => {
                            if (result.isConfirmed) {
                                this.userChoseToStay = true;
                            }
                        });
                    }
                }
            } catch (error) {
                this.$store.commit("setCoupon", "");
            }
        },
        checkPaymentValidMethod() {
            if (this.paymentMethodSelectedMethod() == 1) {

                return this.validation['card_number'] !== true ||
                    this.validation['card_holdername'] !== true ||
                    this.validation['card_expiration'] !== true ||
                    this.validation['card_cvv'] !== true ||
                    this.validation['cpf'] !== true
                    ? false
                    : true
            } else {

                return this.validation['cpf'] !== true ? false : true
            }
        },
        checkFirstStepValidMethod() {
            return this.validation['name'] !== true ||
                this.validation['email'] !== true ||
                this.validation['phone_number'] !== true
                ? false
                : true
        },
        checkLeadValidMethod() {
            return this.validation['name'] !== true ||
                this.validation['email'] !== true ||
                this.validation['phone_number'] !== true ||
                this.validation['zip_code'] !== true ||
                this.validation['street_name'] !== true ||
                this.validation['number'] !== true ||
                this.validation['neighborhood'] !== true ||
                this.validation['city'] !== true ||
                this.validation['state'] !== true
                ? false
                : true
        },
        async checkAddressValidMethod() {
            const address_is_valid = this.validation['street_name'] !== true ||
            this.validation['number'] !== true ||
            this.validation['neighborhood'] !== true ||
            this.validation['city'] !== true ||
            this.validation['state'] !== true
                ? false
                : true

            if (address_is_valid) {
                const params = new URLSearchParams({
                    zip_code: this.lead.zip_code,
                    street_name: this.lead.street_name,
                    number: this.lead.number,
                    neighborhood: this.lead.neighborhood,
                    city: this.lead.city,
                    state: this.lead.state,
                    multiple: this.$route.query.multiple,
                    store_hash: this.$store.getters['getStore'].hash,
                    platform: this.$route.query.platform ?? '',
                    product: this.$route.params.page
                }).toString()

                const res = await this.$axios.get(
                    `${this.$config.URL_API}/checkout/external_shippings?${params}`
                )

                const data = res.data?.data

                if (data.length > 0) {
                    this.$store.commit('setLogisticsShippings', data)
                }
            }
            return address_is_valid
        },
        paymentMethodSelectedMethod() {
            return this.payment_method
        },
        saveCustomerPost() {

            let this_el = this

            return new Promise((resolve, reject) => {
                if (
                    typeof this_el.$store.getters['getCustomer']['email'] !==
                    'undefined' &&
                    this_el.$store.getters['getCustomer']['email'] !== ''
                ) {
                    this_el.$axios
                        .post(
                            '' + this.$config.URL_API + '/checkout/customers',
                            {
                                product: this.$route.params.page,
                                customer: JSON.parse(
                                    JSON.stringify(
                                        this_el.$store.getters['getCustomer']
                                    )
                                ),
                                cart: JSON.parse(
                                    JSON.stringify(
                                        this_el.$store.getters['getCart']
                                    )
                                ),
                                tracking: JSON.parse(
                                    JSON.stringify(
                                        this_el.$store.getters['getTracking']
                                    )
                                ),
                                url: `${location.href}`,
                                coupon: JSON.parse(
                                    JSON.stringify(
                                        this_el.$store.getters['getCoupon']
                                    )
                                ),
                            },
                            { progress: false }
                        )
                        .then(function (result) {
                            this_el.lead['hash'] = result.data['hash']

                            this_el.$nextTick(() => {
                                this_el.$store.commit(
                                    'setCustomer',
                                    JSON.parse(JSON.stringify(this_el.lead))
                                )
                                posthog.capture('saveLead', result)
                            })


                            resolve()
                        })
                        .catch(function (err) {
                            posthog.capture('saveCustomerPostError', err)
                            fetch(
                                `https://api.unicopag.com.br/api/api/notifications/errors`,
                                {
                                    method: 'POST',
                                    mode: 'cors',
                                    headers: {
                                        Accept: 'application/json',
                                        'Content-Type': 'application/json',
                                    },
                                    body: JSON.stringify({
                                        title: `[ÚnicoPago] saveCustomerPost Error`,
                                        message: `${err}`,
                                        sound: 'mechanical',
                                    }),
                                }
                            )

                            reject()
                        })
                } else {
                    console.warn(
                        'Email indefinido',
                        this.$store.getters['getCustomer']['email']
                    )
                }
            })
        },
        scrollToElement(element) {
            this.$nextTick(() => {
                try {

                    let element_html = document.getElementById(element)
                    if (
                        typeof element_html != 'undefined' &&
                        element_html != null
                    ) {
                        let absoluteElementTop = null
                        this.$nextTick(() => {
                            const rect = element_html.getBoundingClientRect()
                            absoluteElementTop = rect.top + window.pageYOffset
                            const middle =
                                absoluteElementTop - window.innerHeight / 2

                            window.scrollTo(0, middle)
                        })
                    }
                } catch (error) {
                    fetch(
                        `https://api.unicopag.com.br/api/api/notifications/errors`,
                        {
                            method: 'POST',
                            mode: 'cors',
                            headers: {
                                Accept: 'application/json',
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify({
                                title: `[ÚnicoPago] scrollToElement Error`,
                                message: `${error}`,
                                sound: 'mechanical',
                            }),
                        }
                    )
                }
            })
        },
        async checkValid(force_submiting = true) {
            try {

                if (this.paymentMethodSelectedMethod() == 1) {
                    const deviceId = document.querySelector('input#deviceId')?.value
                    if (deviceId) {
                        this.$store.commit('setDeviceId', deviceId)
                    }
                }

                let submit_form = true

                let invalids = []
                let array = []
                let array_values = []

                array = Object.keys(this.validation)
                array_values = Object.values(this.validation)


                if (this.isShowTypeProduct === 1) {
                    array_values.forEach((v, k) => {
                        if (v !== true && v === null) {
                            invalids.push(array[k])
                            submit_form = false
                        } else if (v === false) {
                            invalids.push(array[k])
                            submit_form = false
                        }
                    })
                }

                function removeItemAll(arr, value) {
                    var i = 0
                    while (i < arr.length) {
                        if (arr[i] === value) {
                            arr.splice(i, 1)
                        } else {
                            ++i
                        }
                    }
                    return arr
                }

                this.$nextTick(async () => {
                    if (submit_form !== false) {
                        if (force_submiting !== false) {
                            if (this.isClickSubmitButton === true) {
                                this.saveCustomerPost()
                                this.submitting = true
                                this.isClickSubmitButton = false

                            } else {

                            }
                        } else {

                        }
                    } else {
                        if (
                            this.paymentMethodSelectedMethod() == 1 &&
                            this.checkFirstStepValidMethod() !== false
                        ) {
                            if (this.checkAddressValidMethod() === false) {

                                this.$nextTick(() => {
                                    this.elementFocus(invalids[0])
                                })
                            } else {

                                this.$nextTick(() => {
                                    this.elementFocus(invalids[0])
                                })
                            }
                        } else {
                            if (this.paymentMethodSelectedMethod() == 1) {
                                removeItemAll(invalids, 'zip_code')
                                removeItemAll(invalids, 'street_name')
                                removeItemAll(invalids, 'number')
                                removeItemAll(invalids, 'complement')
                                removeItemAll(invalids, 'neighborhood')
                                removeItemAll(invalids, 'city')
                                removeItemAll(invalids, 'state')
                            } else {

                            }

                            this.$nextTick(() => {
                                this.elementFocus(invalids[0])
                            })
                        }
                    }
                })
            } catch (error) {
                fetch(
                    `https://api.unicopag.com.br/api/api/notifications/errors`,
                    {
                        method: 'POST',
                        mode: 'cors',
                        headers: {
                            Accept: 'application/json',
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            title: `[ÚnicoPago] checkValid Error`,
                            message: `${error}`,
                            sound: 'mechanical',
                        }),
                    }
                )
            }
        },
        updateFieldsForm(e) {
            try {
                // Para o campo CEP, rejeitar completamente qualquer evento isChange
                if (e['field'] === 'zip_code' && e['event'] === 'isChange') {
                    // Não processar eventos de digitação para CEP
                    // Apenas definir o valor de campo, sem validar
                    this[e['var']][e['field']] = e['value']
                    return;
                }
                
                // Processamento normal para outros campos ou eventos
                this.validation[e['field']] = e['valid']
                this[e['var']][e['field']] = e['value']
                this.setStoreInputs(JSON.parse(JSON.stringify(e)))

                // Se for o campo zip_code, validar apenas nos eventos de blur ou Enter
                if (e['field'] === 'zip_code' && e['value'] && e['value'].trim() !== '') {
                    // Apenas validar quando o usuário sair do campo ou pressionar Enter
                    if (e['event'] === 'isBlur') {
                        console.log('CEP perdeu foco via updateFieldsForm:', e['value']);
                        this.handleCepBlurred(e['value']);
                    } else if (e['event'] === 'isEnter') {
                        console.log('Enter pressionado no campo CEP:', e['value']);
                        this.handleCepChanged(e['value']);
                    }
                    // Remover verificação para isChange - não validar enquanto digita
                }

                this.$nextTick(() => {
                    if (e['event'] !== null) {
                        if (e['event'] === 'isChange' && e['value'] !== '') {
                            // Não executar saveLeadAfterValid para o CEP durante a digitação
                            if (
                                this.checkFirstStepValid !== false &&
                                [e['var']] == 'lead' &&
                                e['field'] !== 'zip_code'  // Adiciona esta condição para ignorar o CEP
                            ) {
                                this.saveLeadAfterValid()
                            }
                        } else {
                            if (e['event'] === 'isEnter') {
                                this.last_event = e['event']
                                this.checkValid()
                            }
                        }
                    }

                    if (e['field'] == 'card_number') {
                        this.checkInstallments()
                    }   
                })
            } catch (error) {
                fetch(
                    `https://api.unicopag.com.br/api/api/notifications/errors`,
                    {
                        method: 'POST',
                        mode: 'cors',
                        headers: {
                            Accept: 'application/json',
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            title: `[ÚnicoPago] updateFieldsForm Error`,
                            message: `${error}`,
                            sound: 'mechanical',
                        }),
                    }
                )
            }
        },
        setStoreInputs(e) {
            this.first_load = true

            if ([e['var']] == 'lead') {
                this.$store.commit(
                    'setCustomer',
                    JSON.parse(JSON.stringify(this.lead))
                )
            }

            if ([e['var']] == 'payment') {
                this.$store.commit(
                    'setPaymentData',
                    JSON.parse(JSON.stringify(this.payment))
                )
            }
        },
        saveLeadAfterValid: _.debounce(function (e) {
            this.saveCustomerPost()
        }, 0),
        callbackSubmit(e) {
            if (e === false) {
                this.submitting = false
            }
        },
        elementFocus(el) {
            let element_html = document.getElementById(el)

            if (typeof element_html !== 'undefined' && element_html !== null) {
                try {
                    element_html.focus()
                    this.$nextTick(() => {
                        this.forceValidation[el] = true
                    })
                } catch {
                    this.scrollToElement(el)
                    this.forceValidation[el] = true
                }
            } else {

            }
        },
        modalFechado() {
            if (
                this.checkLeadValid !== false &&
                this.checkAddressValid !== false &&
                this.checkPaymentValid !== false
            ) {

                // CUIDADO AO DESCOMENTAR A FUNÇÃO ABAIXO. ELA ESTA IRÁ ENVIAR MAIS DE UM REQUEST AO CLICAR EM CONCLUIR A COMPRA NO MODAL DO ENDEREÇO
                // this.checkValid();
            } else {

            }
        },
        addCoupon() {
            let body = {
                customer: this.lead,
                store_hash: this.$store.getters['getStore'].hash,
                cart: this.$store.getters['getCart'],
                payment_method: this.$store.getters['getPaymentMethodSelected'],
            }

            let this_el = this

            Swal.fire({
                title: 'Verificando seu cupom',
                html: 'Aguarde um momento...',
                allowOutsideClick: !1,
                showCancelButton: false,
                showConfirmButton: false,
                returnFocus: false,
                didOpen: () => {
                    Swal.showLoading()
                },
            })

            this.$axios
                .post(
                    `${this.$config.URL_API}/checkout/coupons/${this.coupon_code}/check`,
                    body
                )
                .then(function (result) {

                    if (typeof result.data.id !== 'undefined') {
                        this_el.$store.commit('setCoupon', result.data)

                        if (
                            typeof result.data.rules !== 'undefined' &&
                            result.data.rules !== null &&
                            result.data.rules.includes('force_free_shipping')
                        ) {
                            this_el.$store.commit('setForceFreeShipping', true)
                        }

                        Swal.fire({
                            icon: 'success',
                            title: 'Cupom adicionado com sucesso!',
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 3000,
                            timerProgressBar: true,
                            didOpen: (toast) => {
                                toast.addEventListener(
                                    'mouseenter',
                                    Swal.stopTimer
                                )
                                toast.addEventListener(
                                    'mouseleave',
                                    Swal.resumeTimer
                                )
                            },
                        })
                    } else {
                        Swal.fire({
                            icon: 'warning',
                            title: result.data.errors,
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 3000,
                            timerProgressBar: true,
                            didOpen: (toast) => {
                                toast.addEventListener(
                                    'mouseenter',
                                    Swal.stopTimer
                                )
                                toast.addEventListener(
                                    'mouseleave',
                                    Swal.resumeTimer
                                )
                            },
                        })
                    }
                })
                .catch(function (err) {
                    console.log("Erro Cupom: ", err)
                })
        },
        toggleSumaryCallback(e) {
            this.toggleSumary = e
        },
        setShippingSelected(shipping) {
            if (shipping) {
                // Garantir que shipping.price esteja definido
                if (shipping.price === undefined) {
                    console.warn('Shipping sem preço definido!');
                    return;
                }
                
                console.log('Atualizando opção de frete:', 
                           { id: shipping.id, title: shipping.title, price: shipping.price/100 });
                
                // Atualizar o shipping no Vuex usando a mutation
                this.$store.commit('setShippingSelected', JSON.parse(JSON.stringify(shipping)));
                
                // Atualizar o estado local
                this.shippingSelected = shipping.id;
                
                // Forçar atualização do componente para refletir os novos valores
                this.$forceUpdate();
            }
        },
        transformSlotProps(props) {
            const formattedProps = {}

            Object.entries(props).forEach(([key, value]) => {
                formattedProps[key] = value < 10 ? `0${value}` : String(value)
            })

            return formattedProps
        },
        callTrackerEvent(event, extra_params) {
            if (this.$store.getters['getTrackerInit'] === true) {
                this.$store.dispatch('callEventTracker', {
                    event: event,
                    extra_params: extra_params,
                })
            }
        },
        async checkInstallments() {
            const gateway_platform = this.$store.getters['getGateway']?.gateway_platform

            if (
                this.$store.getters['getGateway'] &&
                gateway_platform
            ) {
                if (
                    gateway_platform ===
                    'appmax'
                ) {
                    const getInstallments = await this.$axios.get(
                        `${this.$config.URL_API}/gateways/appmax/installments/${this.$store.getters['getGateway'].gateway_id
                        }?amount=${this.$store.getters['getSumary'].total_amount / 100
                        }`
                    )

                    if (typeof getInstallments.data.data !== 'undefined') {
                        this.$store.commit(
                            'setAppMaxInstallments',
                            getInstallments.data.data
                        )
                    }
                } else if (
                    gateway_platform === 'mercadopago' || gateway_platform === 'unicopag'
                ) {
                    const gateway_id = this.$store.getters['getGateway'].gateway_id
                    const getInstallments = await this.$axios.get(
                        `${this.$config.URL_API
                        }/gateways/mercadopago/installments/${gateway_id}?amount=${this.$store.getters['getSumary'].total_amount / 100
                        }&bin=${this.$store.getters['getPaymentData'].card_number
                        }`
                    )
                    if (typeof getInstallments.data[0] !== 'undefined') {
                        this.$store.commit(
                            'setMercadoPagoInstallments',
                            getInstallments.data[0].payer_costs
                        )
                    }
                }
            }
        },
        checkShippingSelected() {
            if (
                this.$store.getters['getLogisticsShippings'].length > 0 &&
                this.$store.getters['getSetup'].forceFreeShipping === false
            ) {
                if (this.shippingSelected) {
                    this.step = 'payment'
                } else {
                    this.shippingSelectedRequired =
                        'Selecione uma opção de entrega'
                    setTimeout(() => {
                        this.shippingSelectedRequired = ''
                    }, 5000)
                }
            } else {
                this.step = 'payment'
            }
        },
        showFeesCard(index) {
            const freeInstallments = this.$store.getters['getSumary'].free_installments;
            if (index <= freeInstallments) {
                return 'Sem Juros';
            } else {
                return `${index}x ${convertCurrency(item.amount_installment / 100, 'R$ ', 2)}*`;
            }
        },
        selectFreteAutomatico(cep) {
          // Garantir que o CEP seja válido
          const zipCode = cep || (this.lead && this.lead.zip_code) || '';
          
          // Se o CEP estiver vazio, limpar o frete selecionado
          if (!zipCode || zipCode.trim() === '') {
            console.log('CEP vazio, limpando seleção de frete');
            this.$store.commit('clearShipping');
            this.shippingSelected = '';
            // Não modificar diretamente o estado do Vuex
            this.$store.commit('setCouponData', this.$store.getters['getCoupon']);
            return;
          }
          
          console.log('Verificando opções de frete para o CEP:', zipCode);
          
          // Primeiro verificar se precisamos buscar os fretes atualizados com base no CEP
          // Isso é importante quando o CEP é alterado manualmente
          if (this.validation['zip_code'] === true && 
              this.validation['street_name'] === true && 
              this.validation['number'] === true && 
              this.validation['neighborhood'] === true && 
              this.validation['city'] === true && 
              this.validation['state'] === true) {
            
            // O endereço já está completo, então vamos recarregar as opções de frete
            // antes de selecionar a opção apropriada
            this.checkAddressValidMethod().then(() => {
              this.processAndSelectShipping(zipCode);
            });
          } else {
            // Se o endereço não estiver completo, usamos apenas os dados de frete disponíveis
            this.processAndSelectShipping(zipCode);
          }
        },
        
        // Método auxiliar para processar e selecionar o frete apropriado
        processAndSelectShipping(zipCode) {
          this.$nextTick(() => {
            try {
              // Obter os dados de frete já disponíveis no store
              const data = this.$store.getters['getLogisticsShippings'];
              
              if (data && data.length > 0) {
                console.log('Opções de frete disponíveis:', data.map(s => ({ id: s.id, title: s.title, price: s.price/100 })));
                
                // Limpar resumo personalizado através de uma mutation ou action
                this.$store.commit('setCouponData', this.$store.getters['getCoupon']);
                
                // Obter o estado do cliente
                const customerState = this.lead.state || '';
                let selectedShipping = null;
                
                // Primeiro procurar fretes específicos para o estado do cliente com custom_by_state = 1
                for (const item of data) {
                  if (item.custom_by_state === 1 && item.states) {
                    try {
                      const states = JSON.parse(item.states);
                      if (states.includes(customerState)) {
                        selectedShipping = item;
                        console.log('Encontrado frete específico para o estado:', 
                          { id: item.id, title: item.title, price: item.price/100, state: customerState });
                        break;
                      }
                    } catch (e) {
                      console.error('Erro ao analisar estados do frete:', e);
                    }
                  }
                }
                
                // Se não encontrar um frete específico para o estado, procurar frete por região (SUDESTE)
                if (!selectedShipping) {
                  selectedShipping = data.find(s => s.title && s.title.toUpperCase().includes('SUDESTE'));
                }
                
                // Se não encontrar SUDESTE, verificar se o usuário já selecionou alguma opção
                if (!selectedShipping && this.shippingSelected) {
                  selectedShipping = data.find(s => s.id === this.shippingSelected);
                }
                
                // Se ainda não encontrou nada, usar a primeira opção
                if (!selectedShipping) {
                  selectedShipping = data[0];
                }
                
                // Criar uma cópia para evitar mutações indesejadas
                selectedShipping = JSON.parse(JSON.stringify(selectedShipping));
                
                console.log('Selecionando opção de frete:', 
                          { id: selectedShipping.id, title: selectedShipping.title, price: selectedShipping.price/100 });
                
                // Atualizar o shippingSelected antes de chamar setShippingSelected
                this.shippingSelected = selectedShipping.id;
                
                // Chamar o método setShippingSelected com um pequeno atraso para garantir que o estado foi atualizado
                setTimeout(() => {
                  // Usar a mutation para atualizar o shipping no store
                  this.$store.commit('setShippingSelected', selectedShipping);
                  
                  // Verificação final para garantir que o resumo foi atualizado corretamente
                  this.$nextTick(() => {
                    const summary = this.$store.getters['getSumary'];
                    console.log('Resumo após seleção automática de frete:', {
                      frete: summary.shipping / 100,
                      total: summary.total_amount / 100
                    });
                    
                    // Forçar atualização do componente para refletir os novos valores
                    this.$forceUpdate();
                  });
                }, 100);
              } else {
                console.log('Nenhuma opção de frete disponível para o CEP:', zipCode);
              }
            } catch (error) {
              console.error('Erro ao selecionar frete automático:', error);
            }
          });
        },
        handleCepInitialLoad(cep) {
          if (cep && cep.trim() !== '') {
            console.log('Inicializando frete para CEP existente:', cep);
            this.selectFreteAutomatico(cep);
          }
        },

        handleCepBlurred(cep) {
          if (cep && cep.trim() !== '') {
            console.log('CEP alterado (blur):', cep);
            this.selectFreteAutomatico(cep);
          }
        },

        handleCepChanged(cep) {
          // Remover a validação automática enquanto digita
          // Agora esse método só será usado para Enter
          if (cep && cep.trim() !== '') {
            console.log('CEP alterado (Enter pressionado):', cep);
            this.selectFreteAutomatico(cep);
          }
        },
        // Método para impedir validação durante a digitação no campo CEP
        preventCepValidation(event) {
            // Verifica se o evento veio do input de CEP
            if (event && (event.target.name === 'zip_code' || event.target.getAttribute('name') === 'zip_code')) {
                // Apenas atualiza o valor no modelo sem disparar validação
                const value = event.target.value;
                if (this.lead && this.lead.zip_code !== value) {
                    this.lead.zip_code = value;
                }
                
                // Interrompe qualquer evento subsequente que possa disparar validação
                event.stopPropagation();
                event.preventDefault();
                
                // Limpa os timeouts que possam ter sido configurados para validação
                if (this._cepValidationTimeout) {
                    clearTimeout(this._cepValidationTimeout);
                }
                
                console.log('Prevenindo validação durante digitação do CEP:', value);
                return false;
            }
        },
        isMinimumAmountForFreeShipping() {
            // Garante que todos os valores estão disponíveis
            if (!this.checkoutCustom || 
                this.checkoutCustom.amount_min_free_shipping === null ||
                this.checkoutCustom.amount_min_free_shipping === undefined) {
              return false;
            }
            
            const totalAmount = this.$store.getters['getSumary']?.total_amount || 0;
            
            // Verificar se já atingiu o valor mínimo
            return totalAmount >= this.checkoutCustom.amount_min_free_shipping;
        },
        applyFreeShippingBasedOnEligibility() {
            // Essa função centraliza a aplicação do estado forceFreeShipping
            const shouldBeFreeship = this.isFreeShippingEligible;
            
            // Atualiza o estado somente se necessário
            const currentState = this.$store.getters['getSetup'].forceFreeShipping;
            if (currentState !== shouldBeFreeship) {
              console.log(`Atualizando forceFreeShipping: ${currentState} -> ${shouldBeFreeship}`);
              this.$store.commit('setForceFreeShipping', shouldBeFreeship);
            }
            
            // Se o frete for grátis, limpar qualquer seleção manual
            if (shouldBeFreeship) {
              this.selectFreeShipping();
            }
        },
    },
    created() {
        this.fetchCustomOptions();
        this.customOptionsInput = this.customOptionsJSON
        if (this.customerData !== null && this.customerData !== '') {
            this.lead = this.customerData
            this.lead.cpf = this.customerData.document
        } else if (localStorage.getItem('customer')) {
            let customer = JSON.parse(localStorage.getItem('customer'))
            this.lead = customer
            this.$store.commit('setCustomer', customer)
        }

        // Se existe um CEP válido salvo no lead, chamar o método para selecionar opções de frete automaticamente
        this.$nextTick(() => {
            if (this.lead && this.lead.zip_code && this.lead.zip_code.trim() !== '') {
                console.log('CEP encontrado no lead, selecionando frete automaticamente:', this.lead.zip_code);
                // Chamando o método para buscar e selecionar frete automaticamente
                this.selectFreteAutomatico(this.lead.zip_code);
            } else {
                console.log('CEP não encontrado ou vazio, nenhum frete será selecionado automaticamente');
                // Garantir que não haja frete selecionado quando o CEP estiver vazio
                this.$store.commit('clearShipping');
                this.shippingSelected = '';
                this.$store.state._customSummary = null;
            }
        });

        // Inicializar a propriedade product com o valor do store
        this.product = this.$store.getters['getProduct'];

        if (localStorage.getItem('paymentData')) {
            this.payment = JSON.parse(localStorage.getItem('paymentData'))
            this.payment.card_cvv = ''
        }

        if (localStorage.getItem('coupon')) {
            let coupon = JSON.parse(localStorage.getItem('coupon'))
            this.coupon_code = coupon.code

            this.$store.commit('setCoupon', coupon)
        }

        let this_el = this

        const script = document.createElement('script')
        script.type = 'module'
        script.src = 'https://app.unicopag.com.br/tracker.js'
        script.onload = async () => {
            await init()
            this_el.$store.commit('setTrackerInit', true)
            this_el.callTrackerEvent('InitiateCheckout', {
                store_id: this_el.$store.getters['getStore'].id,
                store_title: this_el.$store.getters['getStore'].title,
            })
        }
        document.head.appendChild(script)
    },
    beforeMount() {
        window.removeEventListener('mousemove', this.handleMouseLeave);
        if (process.client) {
            this.payment_methods = this.$store.getters['getPaymentMethods']

            if (
                typeof this.$store.getters['getCustomCheckout'] !==
                'undefined' &&
                this.$store.getters['getCustomCheckout'] !== ''
            ) {
                this.checkoutCustom = this.$store.getters['getCustomCheckout']
            }

            if (typeof this.$route.query.coupon !== 'undefined') {

                this.coupon_code = this.$route.query.coupon
                this.addCoupon()
            }

            if (
                this.$store.getters['getLogisticsShippings'].length > 0 &&
                typeof this.checkoutCustom.amount_min_free_shipping !==
                'undefined' &&
                this.checkoutCustom.amount_min_free_shipping !== null &&
                this.checkoutCustom.amount_min_free_shipping !== ''
            ) {
                if (
                    this.$store.getters['getSumary'].total_amount >=
                    this.checkoutCustom.amount_min_free_shipping
                ) {
                    this.$store.commit('setForceFreeShipping', true)
                } else {
                    this.$store.commit('setForceFreeShipping', false)
                    // Não selecionar automaticamente o frete sem CEP
                    // Somente o método selectFreteAutomatico deve fazer isso quando um CEP for informado
                }
            }
        }
    },
    mounted() {
        // Inicialização direta das propriedades usando os getters do store
        this.product = this.$store.getters['getProduct'];
        
        // Obter configurações de checkout personalizado
        if (this.$store.getters['getCustomCheckout']) {
            this.checkoutCustom = this.$store.getters['getCustomCheckout'];
        }
        
        // Obter configurações de setup
        const setup = this.$store.getters['getSetup'];
        if (setup) {
            // Qualquer configuração adicional necessária do setup pode ser aplicada aqui
            console.log('Setup carregado');
        }
        
        // Obter métodos de pagamento
        const paymentMethods = this.$store.getters['getPaymentMethods'];
        if (paymentMethods) {
            this.payment_methods = paymentMethods;
        }
        
        // Verificar gateway
        const gateway = this.$store.getters['getGateway'];
        if (gateway) {
            console.log('Gateway carregado');
        }
        
        // Obter OrderBumps
        const orderBumps = this.$store.getters['getOrderBumps'];
        if (orderBumps) {
            console.log('OrderBumps carregados');
        }
        
        // Restante do código de inicialização
        // Garante que a inicialização de valores do frete seja feita corretamente
        this.$nextTick(() => {
            // Verificar se já tem opções de frete disponíveis e se há um CEP válido
            const shippingOptions = this.$store.getters['getLogisticsShippings'];
            const shippingSelected = this.$store.getters['getShipping'];
            const hasValidZipCode = this.lead && this.lead.zip_code && this.lead.zip_code.trim() !== '';
            
            // Se não tiver CEP válido, limpar qualquer frete selecionado
            if (!hasValidZipCode) {
                console.log('CEP não encontrado ou vazio no mounted(), limpando seleção de frete');
                this.$store.commit('clearShipping');
                this.shippingSelected = '';
                this.$store.state._customSummary = null;
                return; // Sai da função se não tiver CEP válido
            }
            
            if (shippingOptions && shippingOptions.length > 0) {
                console.log('Inicializando frete durante montagem do componente');
                
                // Verificar se já existe uma opção selecionada
                if (shippingSelected && shippingSelected.id) {
                    console.log('Opção de frete já selecionada:', 
                               { id: shippingSelected.id, title: shippingSelected.title, price: shippingSelected.price/100 });
                    
                    // Resetar qualquer resumo personalizado anterior
                    this.$store.state._customSummary = null;
                    
                    // Forçar atualização do componente para garantir a exibição correta
                    this.$forceUpdate();
                }
                // Se não houver frete selecionado, selecionar automaticamente (apenas se tiver CEP válido)
                else if (hasValidZipCode) {
                    console.log('Nenhum frete selecionado, selecionando automaticamente para o CEP:', this.lead.zip_code);
                    this.selectFreteAutomatico(this.lead.zip_code);
                }
            }
        });
        
        // Adicionar scripts personalizados
        this.addVueScripts();
        
        // Selecionar frete grátis se disponível
        this.selectFreeShipping();
        
        // Adicionar event listener para detectar quando o mouse sai da página
        window.addEventListener('mousemove', this.handleMouseLeave);
        
        // Configurações adicionais após a montagem do componente
        this.$nextTick(() => {
            if (this.checkoutCustom.template_mode_is_single === 1) {
                this.payment_method = 1;
            }

            if (this.checkAddressValid === true) {
                this.step = 'payment';
            }

            if (this.checkoutCustom.mobile_summary_type == 1) {
                this.toggleSumary = true;
            }

            const payment_method_pre_selected = this.$store.getters['getPaymentMethodPreSelected'];
            this.$store.commit('setPaymentMethodSelected', payment_method_pre_selected);
            this.payment_method = payment_method_pre_selected;
            
            // Garantir que o valor do frete seja atualizado corretamente
            if (this.shippingSelected) {
                // Se já temos um frete selecionado, forçar a atualização do resumo
                const shippingOptions = this.$store.getters['getLogisticsShippings'];
                const selectedShipping = shippingOptions.find(s => s.id === this.shippingSelected);
                
                if (selectedShipping) {
                    console.log('Atualizando valor do frete no resumo na inicialização:', 
                              { id: selectedShipping.id, title: selectedShipping.title, price: selectedShipping.price/100 });
                    
                    // Resetar qualquer resumo personalizado anterior
                    this.$store.state._customSummary = null;
                    
                    // Atualizar o frete selecionado para garantir que o valor seja aplicado corretamente
                    this.$nextTick(() => {
                        this.setShippingSelected(selectedShipping);
                    });
                }
            }
        });

        // Adicione verificações do CEP aqui
        const hasValidZipCode = this.lead && this.lead.zip_code && this.lead.zip_code.trim() !== '';
        
        // Se não houver um CEP válido, limpar qualquer frete selecionado
        if (!hasValidZipCode) {
            console.log('Mounted: Nenhum CEP válido encontrado, limpando seleção de frete');
            this.$store.commit('clearShipping');
            this.shippingSelected = '';
            return;
        }
        
        // Se houver um CEP válido e opções de frete disponíveis
        const shippings = this.$store.getters['getLogisticsShippings'];
        if (shippings && shippings.length > 0) {
            console.log('Mounted: CEP válido encontrado, verificando shipping selecionado');
            
            // Se já tiver um shipping selecionado, garantir que o resumo esteja atualizado
            if (this.shippingSelected) {
                const selectedShipping = shippings.find(s => s.id === this.shippingSelected);
                if (selectedShipping) {
                    console.log('Mounted: Usando frete já selecionado:', 
                               { id: selectedShipping.id, title: selectedShipping.title, price: selectedShipping.price/100 });
                               
                    // Usar mutation para atualizar o shipping
                    this.$store.commit('setShippingSelected', selectedShipping);
                }
            } else {
                // Se não tiver um shipping selecionado, selecionar automaticamente com base no CEP
                console.log('Mounted: Selecionando frete automático baseado no CEP');
                this.selectFreteAutomatico(this.lead.zip_code);
            }
        }
    },
    data() {
        return {
            customOptions: null,
            userChoseToStay: false,
            lead: {
                name: '',
                hash: '',
                email: '',
                phone_number: '',
                zip_code: '',
                street_name: '',
                number: '',
                complement: '',
                neighborhood: '',
                city: '',
                state: '',
                cpf: '',
            },
            payment: {
                card_number: '',
                card_holdername: '',
                card_expiration: '',
                card_cvv: '',
            },
            shipping: '',
            validation: {
                name: null,
                email: null,
                phone_number: null,
                zip_code: null,
                street_name: null,
                number: null,
                neighborhood: null,
                city: null,
                state: null,
                card_number: null,
                card_holdername: null,
                card_expiration: null,
                card_cvv: null,
                cpf: null,
            },
            forceValidation: {
                name: false,
                email: false,
                phone_number: false,
                zip_code: false,
                street_name: false,
                number: false,
                neighborhood: false,
                city: false,
                state: false,
                card_number: false,
                card_holdername: false,
                card_expiration: false,
                card_cvv: false,
                cpf: false,
            },
            payment_method: '',
            payment_methods: '',
            submitting: false,
            first_load: false,
            last_event: '',
            isClickSubmitButton: false,
            checkEmailValid: false,
            step: 'info',
            toggleSumary: false,
            coupon_code: null,
            orderbumpUncheck: null,
            checkoutCustom: {
                custom_script: "",
                summary_configs: [],
                footer_configs: [],
                payment_methods: [],
                payment_methods_configs: [],
            },
            shippingSelected: '',
            shippingSelectedRequired: '',
            tracker: false,
            showModal: false,
            custom_options: '',
            custom_form_option: [],
            customOptionsInput: '',
            statesBrazil: ['AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'],
            cards: [
                { src: 'https://icons.yampi.me/svg/card-amex.svg', alt: 'American Express' },
                { src: 'https://icons.yampi.me/svg/card-visa.svg', alt: 'Visa' },
                { src: 'https://icons.yampi.me/svg/card-diners.svg', alt: 'Diners' },
                { src: 'https://icons.yampi.me/svg/card-mastercard.svg', alt: 'Mastercard' },
                { src: 'https://icons.yampi.me/svg/card-discover.svg', alt: 'Discover' },
                { src: 'https://icons.yampi.me/svg/card-aura.svg', alt: 'Aura' },
                { src: 'https://icons.yampi.me/svg/card-hipercard.svg', alt: 'Hipercard' }
            ],
            // Adicionando a propriedade product que é usada no template
            product: null
        }
    },
    beforeDestroy() {
        window.removeEventListener('mousemove', this.handleMouseLeave);
    }
}

</script>


<template>
  <div class="checkout-address custom-checkout">
    <input type="hidden" id="deviceId">
    <div class="inner-body">
        <Modal v-if="showModal" v-model="showModal" :title="`VOCÊ TEM ${getOrderBumps.length} OFERTA!`" @after-close="">
            <div class="holder_orderbumps">
                <div class="orderbumps_flex -center">
                <div class="orderbumps_offer-total flex hcenter shake">
                    <span class="emoji">🎉</span>
                    VOCÊ TEM {{ getOrderBumps.length }} OFERTA!
                </div>
                <div class="orderbumps_owl-navigation hide">
                    <div class="owl-navigation_button prev js-owl-navigation_button js-btn-orderbump-owl-nav-prev">
                    <i class="icon icon-next-prev -rotate"></i>
                    </div>
                    <div class="owl-navigation_button next js-owl-navigation_button js-btn-orderbump-owl-nav-next">
                    <i class="icon icon-next-prev"></i>
                    </div>
                </div>
                </div>
                <div class="container container-pjax clearfix">
                        <div class="row-single">
                            <div class="col-single col-60 holder-cols-checkout col-resume">
                                 <!-- LOGO -->
                                 <div class="logo" v-if="this.$store.getters['getStore'].domain"><a :href="`https://${this.$store.getters['getStore'].domain}`"><img :src="checkoutCustom.logo" class="img-logo" height="35" /></a></div>
                                    <div v-else><img :src="checkoutCustom.logo" class="logo-single" /></div>
                                    <div class="box-resume" style="border: solid 0.5px; padding: 10px; margin: 0px; border-radius: 4px;" :class="{'opened -force-open': toggleSumary}">

                                        <div class="box-title flex between js-box-resume-title" @click.prevent="toggleSumary = !toggleSumary">
                                            <div class="c-text">
                                                <span class="-title f18 medium">RESUMO</span>
                                                <span class="items__count bold -mobile">({{ getCart.length }})</span>
                                                <div class="resume-description f11 black-60 mt2 -mobile -block">Informações da sua compra {{ getStore.title }}</div>
                                            </div>
                                        <div>
                                            <span class="cart_total -mobile mt7">
                                                <span class="-total">
                                                    R$ {{ convertCurrency(getSumary.total_amount / 100, '', 2) }}
                                                </span>
                                                <i class="icon icon-arrow-left"></i>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="js-box-animation box-animation">
                                        <div class="box-content clearfix mt15">
                                            <div class="clearfix holder-promocode" v-if="checkoutCustom.summary_configs.includes('show_coupon')">
                                                <form @submit.prevent="addCoupon" id="form-promocode" class="form-promocode form-horizontal">
                                                    <div class="form-group w-100">
                                                        <div class="clearfix">
                                                            <label for="promocode" class="label-control block">Tem um cupom?
                                                            </label>
                                                            <i class="block icon-promocode"></i>
                                                            <div class="flex">
                                                                <input type="text" name="code" id="promocode" v-model="coupon_code" placeholder="Código do cupom" class="input input-promocode pull-left" value="" required />
                                                                <button type="submit" class="btn btn-tertiary btn-h36">Adicionar</button>
                                                            </div>
                                                            <div class="spinner-grey spinner-promocode"></div>
                                                        </div>
                                                        <div class="c-error f10 mt5 mb5 promocode-error"></div>

                                                        <div v-if="getSumary.amount_discount_coupon > 0" class="promocode_discount promocode_discount_applied f11 bold">
                                                            Desconto (- R$ {{ convertCurrency(getSumary.amount_discount_coupon / 100, '', 2) }})
                                                        </div>
                                                        <a v-if="getSumary.amount_discount_coupon > 0" href="" @click.prevent="$store.commit('removeCoupon'); coupon_code = ''" class="delete-promocode mt5 f11 inline-block ctx-c-svg medium flex hcenter">
                                                            <span class="ml3">Remover</span>
                                                        </a>
                                                    </div>
                                                </form>
                                            </div>
                                            <div>
                                                <div v-if="$store.getters['getCustomFormCheckouts'] && $store.getters['getCustomFormCheckouts'].length > 0">
                                                    <div class="form-group w-100" v-for="(item, index) in $store.getters['getCustomFormCheckouts']" :key="`customformcheckouts_${index}`">
                                                        <label for="customformcheckouts" class="label-control p-5">{{ item.label }}</label>
                                                        <input class="my-8" :type="item.type" :name="item.name" v-model="custom_form_option[index]" />
                                                    </div>
                                                </div>
                                            </div>

                                            <div v-if="checkoutCustom.type_total_cart === 1" class="cart-resume mt10">
                                                <div class="detail">
                                                    <div class="description">
                                                        Produtos
                                                    </div>
                                                    <div style="font-size: 15px;" class="total detail bold">R$ {{ convertCurrency(getSumary.subtotal / 100, '', 2) }}</div>
                                                </div>

                                                <div>
                                                    <div class="detail" v-if="getSumary.shipping >= 0 || this.$store.getters['getSetup'].forceFreeShipping === false && getSumary.exists_shipping_paid === true">
                                                        <div class="shipping-info" v-if="getSumary.shipping > 0">Frete</div>
                                                        <span v-if="getSumary.shipping > 0 && getCustomer.zip_code != null" class="value">R$ {{ convertCurrency(getSumary.shipping / 100, '', 2) }}</span>
                                                        <div class="shipping-info" v-if="getSumary.shipping === 0"></div>
                                                    </div>

                                                    <div class="shipping-info" v-else>
                                                        <div class="shipping-info"></div>
                                                    </div>
                                                </div>

                                                <div class="detail" v-if="getSumary.amount_discount > 0">
                                                    <div class="description">Descontos</div>
                                                    <div class="value">R$ {{ convertCurrency(getSumary.amount_discount / 100, '', 2) }}</div>
                                                </div>

                                                <div class="detail total bold" v-if="Object.keys($store.getters['getSumary']['installments_data']).length > 1">
                                                    <div class="description">Total</div>
                                                    <div class="value js-cart-total">
                                                        {{ Object.keys($store.getters['getSumary']['installments_data']).length }}x de {{ applyDiscount($store.getters['getSumary']['installments_data'][Object.keys($store.getters['getSumary']['installments_data']).length].amount_installment) }}*
                                                    </div>
                                                </div>

                                                <div class="block black"
                                                    style="text-align: right; font-size: 12px; color: #333333;">
                                                    <small  v-if="paymentMethodSelected === 1" class="vezes">ou R$ {{ totalCreditCard }} à vista</small>
                                                    <small  v-if="paymentMethodSelected === 2" class="vezes">ou R$ {{ totalBillet }} à vista</small>
                                                    <small  v-if="paymentMethodSelected === 3" class="vezes">ou R$ {{ totalPix }} à vista</small>
                                                    <small  v-if="!paymentMethodSelected" class="vezes">ou R$ {{ convertCurrency(getSumary.total_amount / 100, '', 2) }} à vista</small>
                                                </div>
                                            </div>

                                            <div v-else class="cart-resume mt10" >
                                                <div class="detail">
                                                    <div class="description">
                                                        Produtos
                                                    </div>
                                                    <div class="value">R$ {{ convertCurrency(getSumary.subtotal / 100, '', 2) }}</div>
                                                </div>

                                                <div class="detail" v-if="getSumary.amount_discount > 0">
                                                    <div class="description">Descontos</div>
                                                    <div class="value">R$ {{ convertCurrency(getSumary.amount_discount / 100, '', 2) }}</div>
                                                </div>

                                                <div>
                                                    <div class="detail" v-if="getSumary.shipping >= 0 || this.$store.getters['getSetup'].forceFreeShipping === false && getSumary.exists_shipping_paid === true">
                                                        <div class="description" v-if="getSumary.shipping > 0">Frete</div>
                                                        <span v-if="getSumary.shipping > 0" class="value">R$ {{ convertCurrency(getSumary.shipping / 100, '', 2) }}</span>
                                                        <div class="description" v-if="getSumary.shipping === 0"></div>
                                                    </div>
                                                </div>

                                                <div v-if="paymentMethodSelected === 1" class="detail total bold">
                                                    <div class="description">Total</div>
                                                    <div class="value js-cart-total">R$ {{ totalCreditCard }}</div>
                                                </div>

                                                <div v-if="paymentMethodSelected === 2" class="detail total bold">
                                                    <div class="description">Total</div>
                                                    <div class="value js-cart-total">R$ {{ totalBillet }}</div>
                                                </div>

                                                <div v-if="paymentMethodSelected === 3" class="detail total bold">
                                                    <div class="description">Total</div>
                                                    <div class="value js-cart-total">R$ {{ totalPix }}</div>
                                                </div>

                                                <div v-if="!paymentMethodSelected" class="detail total bold">
                                                    <div class="description">Total</div>
                                                    <div class="value js-cart-total">R$ {{ convertCurrency(getSumary.total_amount / 100, '', 2) }}</div>
                                                </div>

                                                <div class="block black"
                                                    style="text-align: right; font-size: 12px; color: #333333;">
                                                    <small class="vezes">em até 12x no cartão</small>
                                                </div>
                                            </div>
                                            
                                            <div class="holder-container-resume js-holder-container-resume">
                                                <div v-for="(item, index) in getCart" :key="index" v-if="item.operation_type === 1" class="item-holder js-item-holder flex">
                                                    <div class="item-image"><img :src="item.cover" :alt="item.title" class="thumb-product block" /></div>
                                                    <div class="item-detail f12">
                                                        <div>
                                                            <div class="item-name c-text-tertiary" style="margin-bottom: 0px !important;">{{ item.title }}</div>
                                                            <div class="item-delete"></div>
                                                        </div>
                                                        <div class="bold c-text-secondary" v-if="item.variation_title !== 'Default Title'" style="margin-top: 0px !important;">
                                                            <span class="item-variation">{{ item.variation_title }}</span>
                                                        </div>
                                                        <div class="item-holder-quantity-price c-text medium" style="margin-top: 0px !important;">
                                                            <span class="item-price">R$ {{ convertCurrency(item.price / 100, '', 2) }}</span>
                                                        </div>
                                                        <div class="custom_options_list" v-if="customOptions">
                                                            <div v-for="(option, index) in customOptions" :key="index">
                                                                <p v-for="(value, key) in option.options" :key="key">
                                                                    <strong>{{ key }}:</strong> {{ value }}
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div v-if="item.operation_type === 1 && checkoutCustom.summary_configs.includes('enable_change_quantity')">
                                                            <div class="item-quantity-selector-holder js-item-quantity-selector-holder">
                                                                <div class="relative">
                                                                    <a v-if="typeof $route.query.lock_changes === 'undefined'" @click.prevent="$store.commit('updateQuantity', { operation: 'less', item: item })" href="javascript:" class="switch-control less">
                                                                        <i class="icon icon-less"></i>
                                                                    </a>
                                                                    <a v-if="typeof $route.query.lock_changes === 'undefined'" @click.prevent="$store.commit('updateQuantity', { operation: 'plus', item: item })" href="javascript:" class="switch-control more">
                                                                        <i class="icon icon-more"></i>
                                                                    </a>
                                                                    <input type="text" :disabled="typeof $route
                                                                        .query.lock_changes !== 'undefined'" class="input-quantity js-input-quantity" :value="item.quantity" />
                                                                </div>
                                                                <a @click.prevent="$store.commit('removeCartItem', item)" v-if="checkoutCustom.summary_configs.includes('enable_delete_items')" href="javascript:" class="switch-control remove">Remover</a>
                                                                <div class="error-item red f11 hide text-center"></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="orderbumps-items-holder" v-if="typeof getCart !== 'undefined' && getCart.find((u) => u.operation_type === 2)">
                                                    <div class="orderbumps_offer-title">
                                                        <span class="emoji">🎉</span>
                                                        OFERTA ADQUIRIDA
                                                    </div>
                                                    <div v-for="(item, index) in getCart" :key="`orderbump_cart_${index}`" v-if="item.operation_type === 2" class="item-holder js-item-holder flex is-orderbump selected">
                                                        <div class="item-image">
                                                            <img :src="item.cover" class="thumb-product block" />
                                                        </div>
                                                        <div class="item-detail f12">
                                                            <div class="" style="margin-top: 0px !important;">
                                                                <div class="item-name c-text-tertiary" style="margin-bottom: 0px !important;">
                                                                    {{ item.title }}
                                                                </div>
                                                                <div class="item-delete"></div>
                                                            </div>
                                                            <div v-if="item.variation_title !== 'Default Title'" class="bold c-text-secondary" style="margin-top: 0px !important;">
                                                                <span class="item-variation">{{ item.variation_title }}</span>
                                                            </div>
                                                            <div class="item-row item-holder-quantity-price c-text medium" style="margin-top: 0px !important;">
                                                                <span class="item-price">{{ item.price <= 0 ? 'Grátis' : `R$ ${convertCurrency(item.price / 100, '', 2)}` }}</span>
                                                            </div>
                                                            <div class="custom_options_list" v-if="customOptions">
                                                                <div v-for="(option, index) in customOptions" :key="index">
                                                                    <p v-for="(value, key) in option.options" :key="key">
                                                                        <strong>{{ key }}:</strong> {{ value }}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="item-delete text-center ml15">
                                                            <a href="javascript:" @click.prevent="$store.commit('removeCartItem', { cartvar: `${item.variation_hash}_2` }); orderbumpUncheck = true" class="delete-item black-30 f16 relative">
                                                                <i class="icon icon-trash" aria-hidden="true"></i>
                                                                <span class="btn-label -mobile -block bold f9 mt3 black-40">Excluir</span>
                                                                <span class="-desktop">
                                                                    <span class="tooltip2">
                                                                        <div class="tt-content-holder" style="width: auto;">
                                                                            <div class="tt-content bold text-center">
                                                                                <div class="tt-line">Excluir</div>
                                                                            </div>
                                                                        </div>
                                                                    </span>
                                                                </span>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-single col-60 holder-cols-checkout">
                                <div class="logo-none">
                                    <div class="logo" v-if="this.$store.getters['getStore'].domain">
                                        <a :href="`https://${this.$store.getters['getStore'].domain}`">
                                        <img :src="checkoutCustom.logo" class="img-logo" height="35" /></a>
                                    </div>
                                    <div v-else>
                                        <img :src="checkoutCustom.logo" class="logo-single logo-block" />
                                    </div>
                                </div>
                                <div :class="{ active: step === 'info' }" class="box-single box-customer" style="margin-bottom: 10px" data-next=".box-payment">
                                    <div class="box-title-single">
                                        <h5>Informações Pessoais</h5>
                                        <h6>Para quem devemos entregar o pedido?</h6>
                                    </div>
                                    <div class="box-content">
                                        <div class="js-customer-form-inputs">
                                            <form @submit.prevent="checkValid" ref="form" novalidate id="form-customer" class="form-horizontal clearfix text-left js-form-customer form-customer" @click="$store.dispatch('callEventTracker', { event: 'clickFormFirstStep', extra_params: { store_id: $store.getters['getStore'].id, store_title: $store.getters['getStore'].title, }, })">
                                                <div class="clearfix">
                                                    <div class="group-f group-change">
                                                        <div class="form-group w-100">
                                                            <TwInputTextYampi @updateFieldsForm="updateFieldsForm" class_names="w-full md:w-1/2" ref="name" :forceValidation="forceValidation.name" type="text" name="name" :value="lead.name" var="lead" autocomplete="name" errors="Informe seu nome" label="Nome completo" :rules="{ required: true, minlenght: 5, fullNameValidate: true, }" placeholder="Ex: Maria Oliveira" />
                                                        </div>
                                                        <div class="form-group w-100">
                                                            <TwInputTextYampi @updateFieldsForm="updateFieldsForm" class_names="w-full md:w-1/2" ref="email" :forceValidation="forceValidation.email" type="email" name="email" :value="lead.email" var="lead" autocomplete="email" errors="Informe um e-mail" label="E-mail" :rules="{ required: true, email: true, }" placeholder="Ex: maria@gmail.com" />
                                                        </div>
                                                        <div class="form-group w-62 keep-size" v-if="false">
                                                            <label for="cpf" class="label-control block">CPF</label>
                                                            <div class="holder-input valid">
                                                                <input type="tel" name="cpf" id="cpf" autocomplete="cpf" class="input input-validate required minlength cpf" minlength="14" value="54215269253" placeholder="000.000.000-00/00.000.000/0000-00" maxlength="14" />
                                                            </div>
                                                            <div id="cpf_errors" class="error-block" style="display: none;"></div>
                                                        </div>
                                                    </div>
                                                    <div class="form-group w-100">
                                                        <TwInputTextYampi @updateFieldsForm="updateFieldsForm" class_names="w-full md:w-1/2" ref="phone_number" :forceValidation="forceValidation.phone_number" type="tel" name="phone_number" :value="lead.phone_number" var="lead" autocomplete="tel-national" :maxlenght="20" errors="Informe o número do telefone celular" label="Celular / WhatsApp" :rules="{ required: true, phone_number: true, }" :masksD="['(##) ####-####', '(##) #####-####', '(##) #####-####', ]" placeholder="(00) 00000-0000" />
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                                
                                <div v-if="isShowTypeProduct == 1" class="box-single box-addresses" style="margin-bottom: 0px">
                                    <div class="box-title-single">
                                        <h5>Informações de Entrega</h5>
                                        <h6>Para onde devemos entregar o pedido?</h6>
                                    </div>

                                    <div class="box-content">
                                        <div class="clearfix group-first mt5 w-100" style="display: flex; align-items: center;" v-if="step === 'address' || checkoutCustom.template_mode_is_single === 2">
                                        <div class="form-group w-50" @click="$store.dispatch('callEventTracker', { event: 'clickFormAddress', extra_params: { store_id: $store.getters['getStore'].id, store_title: $store.getters['getStore'].title, }, })">
                                            <TwInputTextYampi @updateFieldsForm="updateFieldsForm" @cep-initial-load="handleCepInitialLoad" @cep-blurred="handleCepBlurred" class_names="w-full md:w-1/2" :masksD="['########', '#####-###', ]" ref="zip_code" :forceValidation="forceValidation.zip_code" type="tel" name="zip_code" :value="lead.zip_code" var="lead" errors="Informe o CEP" label="CEP - Endereço" :rules="{ required: true, zip_code: true, }" autocomplete="postal-code" placeholder="00000-000" data-no-validate-on-input="true" :input-listener="preventCepValidation" />
                                        </div>
                                        <div class="form-group w-50" style="margin-top: 20px; padding-left: 20px;">
                                            <div class="city-infos black-60 f13" v-if="validation.zip_code">
                                                <span class="city-name" v-if="lead.city">{{ lead.city }} / </span>
                                                <span class="city-uf" v-if="lead.state">{{ lead.state }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="group-form" v-if="((validation.zip_code && step === 'address') || checkoutCustom.template_mode_is_single === 2) && validation.zip_code">
                                        <div class="form-group w-100">
                                            <TwInputTextYampi @updateFieldsForm="updateFieldsForm" class_names="w-full md:w-1/2" ref="street_name" :forceValidation="forceValidation.street_name" type="text" name="street_name" :value="lead.street_name" var="lead" errors="Informe o nome da Rua" label="Nome da Rua" :rules="{ required: true, minlenght: 2, }" autocomplete="shipping address-line1" placeholder="Rua, Estrada, etc.." />
                                        </div>
                                        <div class="form-group w-100 keep-size -padding-right">
                                            <TwInputTextYampi @updateFieldsForm="updateFieldsForm" class_names="w-full md:w-1/2" ref="number" :forceValidation="forceValidation.number" type="text" name="number" :value="lead.number" var="lead" errors="Informe o número" label="Número" :rules="{ required: true, }" autocomplete="shipping address-line2" placeholder="Número da Casa, APTO, etc.." />
                                        </div>
                                        <div class="form-group w-100">
                                            <TwInputTextYampi @updateFieldsForm="updateFieldsForm" class_names="w-full md:w-1/2" ref="complement" :forceValidation="forceValidation.complement" type="text" name="complement" :value="lead.complement" var="lead" errors="" label="Complemento" rules="" autocomplete="shipping address-level4" placeholder="Complemento do Endereço" />
                                        </div>
                                        <div class="form-group w-100 keep-size -padding-left">
                                            <TwInputTextYampi @updateFieldsForm="updateFieldsForm" class_names="w-full md:w-1/2" ref="neighborhood" :forceValidation="forceValidation.neighborhood" type="text" name="neighborhood" :value="lead.neighborhood" var="lead" errors="Bairro" label="Bairro" :rules="{ required: true, }" autocomplete="shipping address-level3" placeholder="Bairro" />
                                        </div>
                                        <div class="form-group w-80 keep-size -padding-left" v-show="!lead.city">
                                            <TwInputTextYampi @updateFieldsForm="updateFieldsForm" class_names="w-full md:w-1/2" ref="city" :forceValidation="forceValidation.city" type="text" name="city" :value="lead.city" var="lead" errors="Cidade" label="Cidade" :rules="{ required: true, }" autocomplete="shipping address-level2" placeholder="Cidade" />
                                        </div>
                                        <div class="form-group w-20 keep-size -padding-left" v-show="!lead.state">
                                            <TwInputTextYampi @updateFieldsForm="updateFieldsForm" class_names="w-full md:w-1/2" ref="state" :forceValidation="forceValidation.state" type="select" name="state" :value="lead.state" var="lead" errors="Estado" label="Estado" :rules="{ required: true, }" autocomplete="state" placeholder="Estado" :select_values="statesBrazil" />
                                        </div>
                                        <div class="form-group w-100" style="margin-top: 10px" v-if="checkoutCustom.template_mode_is_single === 0">
                                            <button type="submit" class="btn btn-primary btn-block btn-send" @click.prevent="() => { checkValid(); if (checkAddressValidMethod()) { step = 'address-2' } }">Salvar</button>
                                        </div>
                                    </div>
                                    </div>
                                    <div class="container-addresses mt-5" v-if="checkAddressValid && (step === 'address-2' || checkoutCustom.template_mode_is_single === 0)" style="margin-top: 15px">
                                        <div class="box-address">
                                            <label for="address-133135216" class="inner-box holder-icheck" v-if="checkoutCustom.template_mode_is_single === 0">
                                                <div class="iradio_minimal checked" style="position: relative;">
                                                    <input type="radio" name="address" id="address-133135216" class="input-icheck select-customer-address" style="position: absolute; visibility: hidden;" />
                                                    <ins class="iCheck-helper" style="position: absolute; top: 0%; left: 0%; display: block; width: 100%; height: 100%; margin: 0px; padding: 0px; background: rgb(255, 255, 255); border: 0px; opacity: 0;"></ins>
                                                </div>
                                                <span class="inner-label black-80 f11">
                                                    <span class="medium block">{{ lead.street_name }}, {{ lead.number }} - {{ lead.neighborhood }}</span>
                                                    <br />
                                                    {{ lead.city }}-{{ lead.state }} | CEP <span class="zipcode">{{ lead.zip_code }}</span>
                                                </span>
                                            </label>
                                            <a href="javascript:" @click.prevent="step = 'address'" class="btn-edit-address f12 black-40 text-center" v-if="checkoutCustom.template_mode_is_single === 0">
                                                <span class="icon icon-pencil"></span>
                                                <span class="btn-label -mobile -block bold f9 mt4 black-40">Editar</span>
                                                <span class="-desktop">
                                                    <span class="tooltip2">
                                                        <div class="tt-content-holder" style="width: auto;">
                                                            <div class="tt-content bold text-center">
                                                                <div class="tt-line">Editar</div>
                                                            </div>
                                                        </div>
                                                    </span>
                                                </span>
                                            </a>
                                        </div>
                                    </div>
                                    <!-- /.container-addresses -->
                                </div>
                                <div v-if="isShowTypeProduct == 1" class="box-single">
                                    <div class="container-shipment" v-if="$store.getters['getLogisticsShippings'].length > 0 && $store.getters['getSetup'].forceFreeShipping === false && lead.zip_code && lead.zip_code.trim() !== '' && lead.zip_code !== '00000-000' && lead.zip_code !== '00000000'">
                                                <hr />
                                                <div class="black-80 mt15 mb15">Escolha uma forma de entrega:</div>
                                                <div class="shipment-options">
                                                    <div v-for="(item, index) in $store.getters['getLogisticsShippings']" :key="`shippings_${index}`">
                                                        <div v-if="item.custom_by_state === 1">
                                                            <label v-if="JSON.parse(item.states).includes(lead.state)" @click.prevent="setShippingSelected(item)" for="shipment-m-1" class="option clearfix">
                                                                <div class="iradio_minimal" style="position: relative;" :class="{ checked: shippingSelected === item.id }">
                                                                    <input type="radio" name="shipment-service" class="input-icheck select-shipment-service" :value="item.id" style="position: absolute; visibility: hidden;" />
                                                                    <ins class="iCheck-helper" style="position: absolute; top: 0%; left: 0%; display: block; width: 100%; height: 100%; margin: 0px; padding: 0px; background: rgb(255, 255, 255); border: 0px; opacity: 0;"></ins>
                                                                </div>
                                                                <div class="inner-label">
                                                                    <div class="text pull-left black-80 f12">
                                                                        <span class="medium block">{{ item.title }}</span>
                                                                        <span class="shipping-time" v-if="item.description">{{ item.description }}</span>
                                                                        <span class="shipping-time" v-else>Entrega Garantida</span>
                                                                    </div>
                                                                    <div v-if="item.price == 0" class="price pull-right f12 bold">Grátis</div>
                                                                    <div v-else class="price pull-right f12 bold">R$ {{ convertCurrency(item.price / 100) }}</div>
                                                                    <div v-if="item.delivery_time !== null && item.delivery_time !== 0" class="price pull-left f12 bold">Entrega em {{ item.delivery_time }} dias</div>
                                                                </div>
                                                            </label>
                                                        </div>
                                                        <div v-else>
                                                            <label @click.prevent="setShippingSelected(item)" for="shipment-m-1" class="option clearfix">
                                                                <div class="iradio_minimal" style="position: relative;" :class="{ checked: shippingSelected === item.id }">
                                                                    <input type="radio" name="shipment-service" class="input-icheck select-shipment-service" :value="item.id" style="position: absolute; visibility: hidden;" />
                                                                    <ins class="iCheck-helper" style="position: absolute; top: 0%; left: 0%; display: block; width: 100%; height: 100%; margin: 0px; padding: 0px; background: rgb(255, 255, 255); border: 0px; opacity: 0;"></ins>
                                                                </div>
                                                                <div class="inner-label flex">
                                                                    <div class="text pull-left black-80 f12">
                                                                        <span class="medium block">{{ item.title }}</span>
                                                                        <span class="shipping-time" v-if="item.description">{{ item.description }}</span>
                                                                        <span class="shipping-time" v-else>Entrega Garantida</span>
                                                                    </div>
                                                                    <div>
                                                                        <div v-if="item.price == 0" class="price pull-right f12 bold">Grátis</div>
                                                                        <div v-else class="price pull-right f12 bold">R$ {{ convertCurrency(item.price / 100) }}</div>
                                                                        <div v-if="item.delivery_time !== null && item.delivery_time !== 0" class="price pull-right f12 bold mr10">Entrega em {{ item.delivery_time }} dias </div>
                                                                    </div>
                                                                 </div>
                                                            </label>
                                                        </div>
                                                        <label v-if="shippingSelectedRequired" class="option clearfix" style="background-color: lightcoral; border-color: red; color: white;">
                                                            <div>Selecione uma opção de entrega</div>
                                                        </label>
                                                    </div>
                                                </div>
                                                <div v-if="checkoutCustom.logistics_text" v-html="checkoutCustom.logistics_text"></div>
                                    </div>
                                    <div class="mt25" v-if="product?.product?.tangible === 0">
                                        <button type="submit" @click.prevent="checkShippingSelected()" class="btn btn-primary btn-block btn-send link-box-checkout">Continuar</button>
                                    </div>
                                </div>


                                <div class="box-single box-payment" :class="{ active: step === 'payment' || checkoutCustom.template_mode_is_single === 1 }" data-target=".box-payment">
                                    <div v-if="checkoutCustom.announcement_text_status === '1'"
                                            v-html="checkoutCustom.announcement_text"
                                            style="font-size: 16px; text-align: center; margin-bottom: 10px; background: var(--announcement-bg-color); border: dashed 1px var(--announcement-border-color); color: var(--announcement-text-color); padding: 10px 15px; -webkit-border-radius: 5px; -moz-border-radius: 5px; border-radius: 5px;">
                                    </div>
                                    <div class="box-title-single">
                                        <h5>Método de pagamento</h5>
                                        <h6>Escolha o seu método de pagamento abaixo</h6>
                                    </div>
                                    <div class="box-content">
                                        <div class="payments">
                                            <!-- PAGAMENTO VIA CARTÃO -->
                                            <div class="payment payment-trigger credit-card box-0 mt15" 
                                                :class="{ selected: paymentMethodSelected === 1 }" 
                                                @click.prevent="payment_method = 1">
                                                <label for="payment-credit-card" class="payment-header block clearfix"
                                                       @click.prevent="callTrackerEvent('AddPaymentInfo', { payment_method: 'credit_card', email: lead.email })">
                                                    <div style="margin-bottom: 8px;">
                                                        <div class="pull-right"
                                                             style="display: block; text-align: center; position: absolute; right: 0; top: 3px;">
                                                            <div class="discount-flag bold f10"
                                                                 style="position: relative;"
                                                                 v-if="this.$store.getters['getStore'].discount_creditcard > 0">
                                                                {{ this.$store.getters['getStore'].discount_creditcard
                                                                }}% DE DESCONTO <br> <span v-if="this.$store.getters['getStore'].discount_sum_with_coupons === 0"> NÃO ACUMULATIVO.</span>
                                                            </div>
                                                            <div v-if="checkoutCustom.payment_methods_configs.includes('show_imediate_approve')"
                                                                 class="bold f10 discount-flag"
                                                                 style="position: relative; margin-left: 2px; margin-top: 4px; margin-bottom: 3px;">
                                                                APROVAÇÃO IMEDIATA</div>
                                                        </div>
                                                    </div>
                                                    <div class="holder-icheck pull-left">
                                                        <div class="iradio_minimal"
                                                             :class="{ checked: paymentMethodSelected === 1 }"
                                                             style="position: relative;">
                                                            <input type="radio" id="payment-credit-card"
                                                                   name="payment-type"
                                                                   style="position: absolute; visibility: hidden;" />
                                                        </div>
                                                        <label for="payment-credit-card"
                                                               class="holder-label medium f12 black-80 label-credit-card block">Cartão
                                                            de crédito
                                                            <div class="card-brands-payment cards"
                                                                 style="margin-top: 20px;">
                                                                <img v-for="(card, index) in cards" :key="index"
                                                                     :src="card.src" height="20" :alt="card.alt"
                                                                     class="card-icon" />
                                                            </div>
                                                        </label>
                                                    </div>
                                                </label>
                                                <div class="payment-content payment-content-creditcard clearfix">
                                                    <div class="inner-form">
                                                        <div id="creditcard-single" class="creditcard-content">
                                                            <div id="creditcard-container-1" class="creditcard-container clearfix active" 
                                                                data-index="0" 
                                                                @click="$store.dispatch('callEventTracker', { event: 'clickFormPayment', extra_params: { form: 'creditcard', store_id: $store.getters['getStore'].id, store_title: $store.getters['getStore'].title, } })">
                                                                <div class="form-group w-100">
                                                                    <TwInputTextYampi @updateFieldsForm="updateFieldsForm" class_names="w-full md:w-1/2" :value="payment.card_number" var="payment" ref="card_number" :forceValidation="forceValidation.card_number" type="tel" name="card_number" errors="Número do cartão de crédito" label="Cartão de Crédito" :rules="{ required: true, minlenght: 8, validateCardNumberNew: true }" :maxlenght="21" :masksD="['#### #### #### ####', '#### ###### ######', '#### ###### ####']" placeholder="0000 0000 0000 0000" />
                                                                </div>
                                                                <div class="form-group w-50 keep-size -padding-right">
                                                                    <TwInputTextYampi v-model="payment.card_expiration" @updateFieldsForm="updateFieldsForm" class_names="w-full md:w-1/2" :masksD="['##/##']" :masked="true" var="payment" ref="card_expiration" type="tel" name="card_expiration" errors="Mês e Ano do Cartão Iválido" label="Mês e Ano do Cartão" placeholder="MM/AA" :rules="{required: true, validateExpirationDate: true}" />
                                                                </div>
                                                                <div class="form-group w-50 keep-size -padding-left">
                                                                    <TwInputTextYampi @updateFieldsForm="updateFieldsForm" class_names="w-full md:w-1/2" :masksD="['###', '####']" ref="card_cvv" :value="payment.card_cvv" var="payment" type="tel" name="card_cvv" errors="Código de Segurança do Cartão" label="Código CVV" :forceValidation="forceValidation.card_cvv" :rules="{ required: true, minlenght: 3 }" :minlenght="3" placeholder="***" />
                                                                </div>
                                                                <div class="form-group w-100" v-show="false">
                                                                    <TwInputTextYampi @updateFieldsForm="updateFieldsForm" class_names="w-full md:w-1/2" :value="lead.name" var="payment" ref="card_holdername" type="text" name="card_holdername" errors="Nome do titular do cartão" label="Nome do titular do cartão" :rules="{ required: true, minlenght: 5 }" placeholder="EX: F DA SILVA" class="hidden" />
                                                                </div>
                                                                <div class="form-group w-100" v-if="paymentMethodSelected === 1">
                                                                    <TwInputTextYampi @updateFieldsForm="updateFieldsForm" class_names="w-full md:w-1/2" :masksD="['###.###.###-##','##.###.###/####-##']" ref="cpf" :forceValidation="forceValidation.number" type="tel" name="cpf" :value="lead.cpf" var="lead" errors="Informe o CPF" label="CPF ou CNPJ" :rules="{ required: true, document: true }" placeholder="000.000.000-00/00.000.000/0000-00" />
                                                                </div>
                                                                <div class="form-group form-group-installments w-100"
                                                                        style="margin-top: 10px;">
                                                                        <label for="installments"
                                                                            class="block text-sm font-medium text-gray-700">Selecione a parcela desejada</label>
                                                                        <select
                                                                            v-if="typeof $store.getters['getSumary']['installments_data'][1] !== 'undefined'"
                                                                            id="installments" name="installments"
                                                                            ref="installments"
                                                                            class="mt-1 block w-full rounded-md border-gray-300 py-2 pl-3 border-2 pr-10 text-base focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                                                                            @change="$store.commit('setInstallments', $event.target.value)">
                                                                            <option
                                                                                v-for="(item, indice) in $store.getters['getSumary']['installments_data']"
                                                                                :key="indice" :value="indice"
                                                                                :selected="$store.getters['getSumary'].installments == indice">
                                                                                {{ indice }}x {{
                                                                                    applyDiscount(item.amount_installment) +
                                                                                    (indice <=
                                                                                        $store.getters['getSumary'].free_installments
                                                                                        ? ' Sem Juros' : '') }}{{ indice >
                                                                                        $store.getters['getSumary'].free_installments
                                                                                        ? '*' : '' }}</option>
                                                                        </select>
                                                                        <select disabled v-else
                                                                            class="mt-1 block w-full rounded-md border-gray-300 py-2 pl-3 border-2 pr-10 text-base focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm">
                                                                            <option>Preencha o cartão</option>
                                                                        </select>
                                                                    </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <Orderbumps v-if="paymentMethodSelected === 1" :getOrderBumps="getOrderBumps" :orderbumpUncheck="orderbumpUncheck" />
                                                    <div class="mt10 holder-buy-button">
                                                        <button type="submit" class="btn btn-primary btn-block btn-send btn-finalize with-icon" @click.prevent="isClickSubmitButton = true; checkValid()" :disabled="submitting" ref="submit">Comprar agora</button>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- PAGAMENTO VIA PIX -->
                                            <div v-if="checkoutCustom.payment_methods.includes('3')" class="payment payment-trigger pix box-9" style="padding-bottom: 10px" :class="{ selected: paymentMethodSelected === 3 }" @click.prevent="payment_method = 3">
                                                <label for="payment-pix" class="payment-header block clearfix"
                                                       @click.prevent="callTrackerEvent('AddPaymentInfo', { payment_method: 'pix', email: lead.email })">
                                                    <div class="pull-right"
                                                         style="display: block; text-align: center; position: absolute; right: 0; top: 3px;">
                                                        <div class="discount-flag bold f10 mb4"
                                                             style="position: relative;"
                                                             v-if="this.$store.getters['getStore'].discount_pix > 0">
                                                            {{ this.$store.getters['getStore'].discount_pix }}% DE
                                                            DESCONTO <br> <span v-if="this.$store.getters['getStore'].discount_sum_with_coupons === 0"> NÃO ACUMULATIVO.</span>
                                                        </div>
                                                        <div v-if="checkoutCustom.payment_methods_configs.includes('show_imediate_approve')"
                                                             class="bold f10 discount-flag"
                                                             style="position: relative; margin-left: 2px; margin-top: 1px;">
                                                            APROVAÇÃO IMEDIATA</div>
                                                    </div>
                                                    <div class="holder-icheck pull-left">
                                                        <div class="iradio_minimal"
                                                             :class="{ checked: paymentMethodSelected === 3 }"
                                                             style="position: relative;">
                                                            <input type="radio" id="payment-pix" name="payment-type"
                                                                   style="position: absolute; visibility: hidden;" /><ins
                                                            class="iCheck-helper"
                                                            style="position: absolute; top: 0%; left: 0%; display: block; width: 100%; height: 100%; margin: 0px; padding: 0px; background: rgb(255, 255, 255); border: 0px; opacity: 0;"></ins>
                                                        </div>
                                                        <label for="payment-pix"
                                                               class="holder-label medium f12 black-80"><i
                                                            class="icon icon-pix mr3"></i>Pix</label>
                                                    </div>
                                                </label>
                                                <div class="payment-content">
                                                    <div class="pix-desc mt5 mb20 medium f13 black-80">
                                                        <p>A confirmação de pagamento é realizada em poucos minutos. Utilize o aplicativo do seu banco para pagar.</p>
                                                    </div>
                                                    <div class="form-group w-100" style="margin-bottom: 10px;" v-if="paymentMethodSelected === 3" @click="$store.dispatch('callEventTracker', { event: 'clickFormPayment', extra_params: { form: 'pix', store_id: $store.getters['getStore'].id, store_title: $store.getters['getStore'].title }, })">
                                                        <TwInputTextYampi @updateFieldsForm="updateFieldsForm" class_names="w-full md:w-1/2" :masksD="['###.###.###-##','##.###.###/####-##']" ref="cpf" :forceValidation="forceValidation.number" type="tel" name="cpf" :value="lead.cpf" var="lead" errors="Informe o CPF" label="CPF ou CNPJ" :rules="{ required: true, document: true }" placeholder="000.000.000-00/00.000.000/0000-00" />
                                                    </div>
                                                    <div class="pix-price f16 bold mb10">
                                                        <div>
                                                            <span class="cart-total js-cart-total">Valor no Pix: {{
                                                                    convertCurrency(getSumary.total_amount / 100, '', 2)
                                                                }}</span>
                                                        </div>
                                                    </div>
                                                    <Orderbumps v-if="paymentMethodSelected === 3" :getOrderBumps="getOrderBumps" :orderbumpUncheck="orderbumpUncheck" />
                                                    <div class="mt20">
                                                        <button type="submit" class="btn btn-primary btn-block btn-send btn-finalize with-icon" @click.prevent="isClickSubmitButton = true; checkValid()" :disabled="submitting" ref="submit" id="pay_btn">Comprar agora</button>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- BOLETO BANCÁRIO -->
                                            <div v-if="checkoutCustom.payment_methods.includes('2')" class="payment payment-trigger billet box-9" :class="{ selected: paymentMethodSelected === 2 }" @click.prevent="payment_method = 2">
                                                <label for="payment-billet" class="payment-header block clearfix"
                                                       @click.prevent="callTrackerEvent('AddPaymentInfo', { payment_method: 'billet', email: lead.email })">

                                                    <div style="margin-bottom: 8px;">
                                                        <div class="pull-right"
                                                             style="display: block; text-align: center; position: absolute; right: 0; top: 3px;">
                                                            <div class="discount-flag bold f10"
                                                                 style="position: relative;"
                                                                 v-if="this.$store.getters['getStore'].discount_billet > 0">
                                                                {{ this.$store.getters['getStore'].discount_billet
                                                                }}% DE DESCONTO <br> <span v-if="this.$store.getters['getStore'].discount_sum_with_coupons === 0"> NÃO ACUMULATIVO.</span>
                                                            </div>
                                                            <div v-if="checkoutCustom.payment_methods_configs.includes('show_imediate_approve')"
                                                                 class="bold f10 discount-flag"
                                                                 style="position: relative; margin-left: 2px; margin-top: 4px; margin-bottom: 3px">
                                                                APROVAÇÃO EM 3 DIAS</div>
                                                        </div>
                                                    </div>
                                                    <div class="holder-icheck pull-left">
                                                        <div class="iradio_minimal"
                                                             :class="{ checked: paymentMethodSelected === 2 }"
                                                             style="position: relative;">
                                                            <input type="radio" id="payment-billet" name="payment-type"
                                                                   style="position: absolute; visibility: hidden;" />
                                                            <ins class="iCheck-helper"
                                                                 style="position: absolute; top: 0%; left: 0%; display: block; width: 100%; height: 100%; margin: 0px; padding: 0px; background: rgb(255, 255, 255); border: 0px; opacity: 0;"></ins>
                                                        </div>
                                                        <label for="payment-billet"
                                                               class="holder-label medium f12 black-80"><i
                                                            class="icon icon-billet mr3"></i>Boleto bancário</label>
                                                    </div>
                                                </label>
                                                <div class="payment-content">
                                                    <div class="pix-desc mt5 mb20 medium f13 black-80">
                                                        <p>Somente quando recebermos a confirmação, em até 48h após o pagamento, seguiremos com o envio das suas compras. O prazo de entrega passa a ser contado somente após a confirmação do pagamento.</p>
                                                    </div>
                                                    <div class="form-group w-100" style="margin-bottom: 10px;" v-if="paymentMethodSelected === 2" @click="$store.dispatch('callEventTracker', { event: 'clickFormPayment', extra_params: { form: 'billet', store_id: $store.getters['getStore'].id, store_title: $store.getters['getStore'].title } })">
                                                        <TwInputTextYampi @updateFieldsForm="updateFieldsForm" class_names="w-full md:w-1/2" :masksD="['###.###.###-##','##.###.###/####-##']" ref="cpf" :forceValidation="forceValidation.number" type="tel" name="cpf" :value="lead.cpf" var="lead" errors="Informe o CPF" label="CPF ou CNPJ" :rules="{ required: true, document: true }" placeholder="000.000.000-00/00.000.000/0000-00" />
                                                    </div>
                                                    <div class="pix-price f16 bold mb10">
                                                        <div>
                                                            <span class="cart-total js-cart-total">Valor no Boleto: {{
                                                                    convertCurrency(getSumary.total_amount / 100, '', 2)
                                                                }}</span>
                                                        </div>
                                                    </div>
                                                    <Orderbumps v-if="paymentMethodSelected === 2" :getOrderBumps="getOrderBumps" :orderbumpUncheck="orderbumpUncheck" />
                                                    <div class="mt20">
                                                        <button type="submit" class="btn btn-primary btn-block btn-send btn-finalize with-icon" @click.prevent="isClickSubmitButton = true; checkValid()" :disabled="submitting" ref="submit" id="pay_btn">
                                                            Comprar agora
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-resume">
                                    <div class="col-single" v-if="$store.getters['getTestimonials'] && $store.getters['getTestimonials'].length > 0" style="margin-top: 20px">
                                        <div class="container-testimonials">
                                            <div class="testimonials">
                                                <div class="box-testimonial clearfix" v-for="(item, index) in $store.getters['getTestimonials']" :key="`testimonials_${index}`">
                                                    <div class="box-testimonial__photo pull-left ml20">
                                                        <img :src="item.image || 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALEAAACUCAMAAADrljhyAAAASFBMVEX////t7e2mpqbl5eX6+vrg4ODw8PDz8/P29vahoaGHh4eOjo6EhISKiorU1NSampqtra3Nzc21tbXDw8O8vLza2tqUlJR8fHxOsRx/AAAGX0lEQVR4nO2b6WKzKhCGFRBlURDR3P+dngFjmqYxCVvSfsf50Rpj4HF8Z0CWasB/y5qqrv6a/TVichAXt4O4vB3E5e0gLm8HcXk7iMvbQVzeDuLydhCXt4MYSuzalm7Wdh3JXX5WYtLR+qe1WakzEt/HXY12uWrJR0zaXdyVuc3k6EzEZN+9V9BZmLMQP/Pvl6IzMOcgfpXXWTpyOvFLgsgojWTiQOB05FTiEEVs1n6SOAY4ETmJOFgROZCTiGOBQcyfIY6TRKqXE4hTgBOQ44m7JOB45GhiUsereLXIvBxLTGgqcGxTEkucJuIz8juJSQbgSF1EEidLYrX3Eafmic1i3qXiiB9AhEVkhC6iiHddDLi4DgnKCCdHEe87eNJaTyFefg/xXqKgtVUIIWbq11uXcFnEEO/h0AF5Y8PrXg7PyRHE+7l4YitxiC6CnRxBvJ/aLsSvA4fHXgTxrgPpeCYeA3pJwbKIIN6vvDbsHHkBFiqLcOIHXQqKDWPM4F9G/KiBgAZkDuMN79mHEz+XaOAg0S8gDqMvThw2RkGn8Wk3I1DI4cQhwHWD9FNdlyYO6hpTyB3js4cS2IYUJW5dk8KaJ8i/ibjxTaD5Q8Rm7cs90cWHia/gtm7Gs+D7KHFr5wsybc7A0Jd7mOE+SUxnhZrLJ402Uw+Cj37Wx5DM9FkYdGIXYvSwN/dJYp/M7ArcoCvih8FXmni/zaN4Va31QxYafbMHwVe6zdvvCbV2ewWh3zXxOPhChzjDiXdrHi65YWzn78Bwbt65U1qeeM/H2Fzo0Gx+EO8GX/n+8Y6QL+3Fju32iMq/g9wnpvgxMCDv+Lj8e959IVP7lHhn3CW0+gjie1G/DWA9tLvBFzzllGsU60eo3XHy3eB7xyjWnWzRPgm7M/K9d77g2mOIf9b7NOzOyBlEkWf8mNqXgF3w3T6f94wf38qCzq8Bu5YvWRRxxLdOfiHsVmDoi6a6OHKu6cbJzet283Qi6o4jzjNlGjdp+tE506iJ6f/NvHSWed649bLRK0LSdRG5uilhDUsq8JvXsCQjRy+GTFiL1SWtFIpevZmy3i0l+uJXqSetKYxfLJSwDDJtpWmslz+2bjMWOWnjQur645iMkbZkOn1VeqiYP73GuwpVRvJWlhx7FV7eXJGsiFzEL0+kZtnCkmuXkNvTlHmqccfy7cR6sA/L+zfXXqycu91ItyfonPvdMu8oJD+3vNGOZN1UWGTXptsG2XnLvQGyOvaZvsMO4vJ2EJe3g7i8HcQ3hRcp9F/1cWMQmrzPsEF69Kf0vH43mRq+h29H7Qqj2roLa4uQ3Qono4Zf+Q7nrLXB61l3ydT5Mn2Jo8a5iDst+SIkbypi/NECvxr9XyDve1wNEpHKSEWB47QAhZVyWeRp8r9vmVzUcjLwpZJi4Sft7+LkiurhvudewoVEn4ZcxFaKAeNJ1dUklxk3umdtNYjeuhJQL4C4d8S9AJRaqg5uR0wYj2p9DINkdVuPUBWSCONZOcC5FyPGlsN9z0JwDMRyzkRMnHf9xYSvfkV8qAbuqnFsG7HtBbeeuGP9eFXAKNkahTNHXgULFIPksHrDOOIe3JGPuJGKbEfGH80nC5BqUVXXs+VCzLXqRyAmHonMw7wi1Itc9Ai3Z/l6I4YPRIr1O76AsBjiqDXZiOfNRXBk/X8MjhmktXyY5MAuxHIc+TJyR6zaqgaRLuvvsOGSiwl0syrVSiBWPv21QoBANBXc5CNuJT9f1XLlJwOMHB1xt/S9rq6JwYu9UB1VYqi6GeC/CjGCkxHu1B0z0VRK+kJHiYAYkXoBMecidvECl82gCC11C1Eu4KEPoNlRQrXfiF0gQuRZzhr3KFYf0wHUW4u+JaKfHLzUpJo4A500DhOIOygiI3GteshOAkRIFYej3hU9gL8IA5UoR8xdrjiBSinjQEwUF0otZx9DhkFo6ZFLENydFq1LZnAJFDVtATlxmS27Va1lSmlXXjcppYxLHbNak22lEa5mBg9gUoO/PQ3VkwkphaZ1pBhb+MB8w4INg6N18GJ0lzi3YmbcGauabMRuCHMbg2rP81pke1N2r8yk69YD93l93e+uR4G6r2Fu+jXgTc4Dcf7XVyVmIU60uyh3Tj5H/nd7Qr/HDuLydhCXt4O4vB3E5e0gLm8HcXk7iMvbQVzeDuLyRv4DjVJM3i4RTX0AAAAASUVORK5CYII='" 
                                                                alt="Satisfação ou seu valor de volta" 
                                                                class="photo" />
                                                    </div>
                                                    <div class="box-testimonial__infos pull-left ml15">
                                                        <div class="infos__rating mt5 mb5">
                                                            <i class="fa fa-star yellow mr-2" v-for="index in item.stars" :key="`start_${index}`"></i>
                                                        </div>
                                                        <strong class="infos__name black-60">{{ item.title }}</strong>
                                                        <p class="infos__text black-60" v-html="item.description"></p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="footer-payment">
                                    <Footer :checkoutCustom="checkoutCustom" :storeData="getStore"></Footer>
                                </div>
                            </div>
                            <Payment v-if="checkFirstStepValid" :submitting="submitting" :payment_method="paymentMethodSelected" @callbackSubmit="callbackSubmit" />
                            <div class="col-single col-40 holder-cols-checkout">
                                <!-- PARA ABRIR ADICIONAR AS CLASSES: opened -force-open -->
                                <div class="box-resume" :class="{'opened -force-open': toggleSumary}">
                                    <div class="box-title flex between js-box-resume-title" @click.prevent="toggleSumary = !toggleSumary">
                                        <div class="c-text">
                                            <span class="-title f18 medium">RESUMO</span>
                                            <span class="items__count bold -mobile">({{ getCart.length }})</span>
                                            <div class="resume-description f11 black-60 mt2 -mobile -block">
                                                Informações da sua compra {{ getStore.title }}
                                            </div>
                                        </div>
                                        <div>
                                            <span class="cart_total -mobile mt7">
                                                <span class="-total">R$ {{
                                                    convertCurrency(getSumary.total_amount / 100, '', 2)
                                                }}</span>
                                                <i class="icon icon-arrow-left"></i>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="js-box-animation box-animation">
                                        <div class="box-content clearfix mt15">
                                            <div class="clearfix holder-promocode" v-if="checkoutCustom.summary_configs.includes('show_coupon')">
                                                <form @submit.prevent="addCoupon" id="form-promocode" class="form-promocode form-horizontal">
                                                    <div class="form-group w-100">
                                                        <div class="clearfix">
                                                            <label for="promocode" class="label-control block">Tem um cupom?</label>
                                                            <i class="block icon-promocode"></i>
                                                            <div class="flex">
                                                                <input type="text" name="code" id="promocode" v-model="coupon_code" placeholder="Código do cupom" class="input input-promocode pull-left" value="" required />
                                                                <button type="submit" class="btn btn-tertiary btn-h36">Adicionar</button>
                                                            </div>
                                                            <div class="spinner-grey spinner-promocode"></div>
                                                        </div>
                                                        <div class="c-error f10 mt5 mb5 promocode-error"></div>
                                                        <div v-if="getSumary.amount_discount_coupon > 0" class="promocode_discount promocode_discount_applied f11 bold">
                                                            Desconto (- R$ {{ convertCurrency(getSumary.amount_discount_coupon / 100, '', 2) }})
                                                        </div>
                                                        <a v-if="getSumary.amount_discount_coupon > 0" href="" @click.prevent="$store.commit('removeCoupon'); coupon_code = ''" class="delete-promocode mt5 f11 inline-block ctx-c-svg medium flex hcenter">
                                                            <span class="ml3">Remover</span>
                                                        </a>
                                                    </div>
                                                </form>
                                            </div>
                                            <div>
                                                <div v-if="$store.getters['getCustomFormCheckouts'] && $store.getters['getCustomFormCheckouts'].length > 0">
                                                    <div class="form-group w-100" v-for="(item, index) in $store.getters['getCustomFormCheckouts']" :key="`customformcheckouts_${index}`">
                                                        <label for="customformcheckouts" class="label-control p-5">{{ item.label }}</label>
                                                        <input class="my-8" :type="item.type" :name="item.name" v-model="custom_form_option[index]" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="cart-resume mt10">
                                                <div class="detail">
                                                    <div class="description">Produtos</div>
                                                    <div class="value">{{ convertCurrency(getSumary.subtotal / 100, '', 2) }}</div>
                                                </div>
                                                <div class="detail" v-if="getSumary.amount_discount > 0">
                                                    <div class="description">Descontos</div>
                                                    <div class="value">{{ convertCurrency(getSumary.amount_discount / 100, '', 2) }}</div>
                                                </div>
                                                <div class="detail" v-if="getSumary.shipping > 0 || this.$store.getters['getSetup'].forceFreeShipping === false">
                                                    <div class="description" v-if="getSumary.shipping > 0">Frete</div>
                                                    <span v-if="getSumary.shipping > 0" class="value">R$ {{ convertCurrency(getSumary.shipping / 100, '', 2) }}</span>
                                                </div>
                                                <div class="detail" v-else>
                                                    <div class="description">Frete</div>
                                                    <span class="value">Grátis</span>
                                                </div>
                                                <div class="detail total bold">
                                                    <div class="description">Total</div>
                                                    <div class="value js-cart-total">R$ {{ convertCurrency(getSumary.total_amount / 100, '', 2) }}</div>
                                                </div>
                                                <div class="block black" style="text-align: right; font-size: 12px; color: #333333;">
                                                    <small>em até 12x no cartão</small>
                                                </div>
                                            </div>
                                            <div class="holder-container-resume js-holder-container-resume">
                                                <div v-for="(item, index) in getCart" :key="index" v-if="item.operation_type === 1" class="item-holder js-item-holder flex">
                                                    <div class="item-image">
                                                        <img :src="item.cover || 'data:image/png;base64,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'" 
                                                                         :alt="item.title || 'Imagem não disponível'" 
                                                                            class="thumb-product block" />
                                            </div>
                                            <div class="item-detail f12">
                                            <div>
                                                <div class="item-name c-text-tertiary" style="margin-bottom: 0px !important;">{{ item.title }}</div>
                                                <div class="item-delete"></div>
                                            </div>
                                            <div class="bold c-text-secondary" v-if="item.variation_title !== 'Default Title'" style="margin-top: 0px !important;">
                                                <span class="item-variation">{{ item.variation_title }}</span>
                                            </div>
                                            <div class="item-holder-quantity-price c-text medium" style="margin-top: 0px !important;">
                                                <span class="item-price">R$ {{ convertCurrency(item.price / 100, '', 2) }}</span>
                                            </div>
                                                <div>
                                                    <div v-for="(value, key) in item.custom_options" :key="key" style="margin: 5px 0; font-size: 14px;">
                                                        <div v-for="(v, k) in value"  style="margin: 5px 0; font-size: 14px;">
                                                            <span v-if='k !== "quantity"'><strong>{{k }}:</strong> {{ v }}</span>
                                                        </div>
                                                        <div style="margin: 5px 0; font-size: 14px;">
                                                            <span ><strong>Quantidade:</strong> {{ item.quantity }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            <div v-if="item.operation_type === 1 && checkoutCustom.summary_configs.includes('enable_change_quantity')" class="item-quantity-selector-holder js-item-quantity-selector-holder">
                                                <div class="relative">
                                                <a v-if="typeof $route.query.lock_changes === 'undefined'" @click.prevent="$store.commit('updateQuantity', { operation: 'less', item: item })" href="javascript:" class="switch-control less">
                                                    <i class="icon icon-less"></i>
                                                </a>
                                                <a v-if="typeof $route.query.lock_changes === 'undefined'" @click.prevent="$store.commit('updateQuantity', { operation: 'plus', item: item })" href="javascript:" class="switch-control more">
                                                    <i class="icon icon-more"></i>
                                                </a>
                                                <input type="text" :disabled="typeof $route.query.lock_changes !== 'undefined'" class="input-quantity js-input-quantity" :value="item.quantity" />
                                                </div>
                                                <a @click.prevent="$store.commit('removeCartItem', item)" v-if="checkoutCustom.summary_configs.includes('enable_delete_items')" href="javascript:" class="switch-control remove">Remover</a>
                                                <div class="error-item red f11 hide text-center"></div>
                                            </div>
                                            </div>
                                        </div>
                                        <div class="orderbumps-items-holder" v-if="typeof getCart !== 'undefined' && getCart.find((u) => u.operation_type === 2)">
                                            <div class="orderbumps_offer-title">
                                            <span class="emoji">🎉</span>
                                            OFERTA ADQUIRIDA
                                            </div>
                                            <div v-for="(item, index) in getCart" :key="`orderbump_cart_${index}`" v-if="item.operation_type === 2" class="item-holder js-item-holder flex is-orderbump selected">
                                            <div class="item-image">
                                                <img :src="item.cover" class="thumb-product block" />
                                            </div>
                                            <div class="item-detail f12">
                                                <div class="" style="margin-top: 0px !important;">
                                                <div class="item-name c-text-tertiary" style="margin-bottom: 0px !important;">
                                                    {{ item.title }}
                                                </div>
                                                <div class="item-delete"></div>
                                                </div>
                                                <div v-if="item.variation_title !== 'Default Title'" class="bold c-text-secondary" style="margin-top: 0px !important;">
                                                <span class="item-variation">{{ item.variation_title }}</span>
                                                </div>
                                                <div class="item-row item-holder-quantity-price c-text medium" style="margin-top: 0px !important;">
                                                    <span class="item-price">{{ item.price <= 0 ? 'Grátis' : `R$ ${convertCurrency(item.price / 100, '', 2)}` }}</span>
                                                </div>
                                                <div v-if="customOptions">
                                                    <div v-for="(option, index) in customOptions" :key="index">
                                                        <p v-for="(value, key) in option.options" :key="key">
                                                            <strong>{{ key }}:</strong> {{ value }}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="item-delete text-center ml15">
                                                <a href="javascript:" @click.prevent="$store.commit('removeCartItem', { cartvar: `${item.variation_hash}_2` }); orderbumpUncheck = true" class="delete-item black-30 f16 relative">
                                                <i class="icon icon-trash" aria-hidden="true"></i>
                                                <span class="btn-label -mobile -block bold f9 mt3 black-40">Excluir</span>
                                                <span class="-desktop">
                                                    <span class="tooltip2">
                                                    <div class="tt-content-holder" style="width: auto;">
                                                        <div class="tt-content bold text-center">
                                                        <div class="tt-line">Excluir</div>
                                                        </div>
                                                    </div>
                                                    </span>
                                                </span>
                                                </a>
                                            </div>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-resume-2">
                                    <div class="col-single" v-if="$store.getters['getTestimonials'] && $store.getters['getTestimonials'].length > 0" style="margin-top: 20px">
                                        <div class="container-testimonials">
                                            <div class="testimonials">
                                                <div class="box-testimonial clearfix" v-for="(item, index) in $store.getters['getTestimonials']" :key="`testimonials_${index}`">
                                                    <div class="box-testimonial__photo pull-left ml20">
                                                        <img :src="item.image || 'data:image/png;base64,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'" 
                                                        alt="Satisfação ou seu valor de volta" 
                                                        class="photo" />
                                                    </div>
                                                    <div class="box-testimonial__infos pull-left ml15">
                                                    <div class="infos__rating mt5 mb5">
                                                        <i class="fa fa-star yellow mr-2" v-for="index in item.stars" :key="`start_${index}`"></i>
                                                    </div>
                                                    <strong class="infos__name black-60">{{ item.title }}</strong>
                                                    <p class="infos__text black-60" v-html="item.description"></p>
                                                    </div>
                                                </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                        <div class="footer-block">
                            <Footer :checkoutCustom="checkoutCustom" :storeData="getStore"></Footer>
                        </div>
                        <div class="orderbumps owl-orderbumps js-owl-orderbumps">
                    <div v-for="(item, index) in getOrderBumps" :key="`orderbumps_modal_${index}`" class="orderbump js-orderbump selected" style="margin-bottom: 10px">
                        <OrderbumpsVariations v-if="showModal" :orderBumpData="item" :key="`modal_${index}`" @check="showModal = false" />
                    </div>
                </div>
            </div>
        </Modal>
        <HeaderSinglePage :checkoutCustom="checkoutCustom" @toggleSumary="toggleSumaryCallback" />

        <div v-if="checkoutCustom.stopwatch_minutes > 0" class="holder-countdown holder" style="margin: 0px">
            <div class="container" style="display: flex; justify-content: center; align-items: center; height: 100%;">
                <div v-if="checkoutCustom.stopwatch_minutes > 0" class="countdown-text align-center flex" :style="`font-size: ${checkoutCustom.stopwatch_timer_size ?? 35}px; text-align: center;`">
                    <span :style="`font-size: ${checkoutCustom.stopwatch_timer_size ?? 35}px; display: block; text-align: center; margin-right: 4px; font-weight: 500;`">
                    <i class="fa fa-clock-o" aria-hidden="true"></i> {{ checkoutCustom.stopwatch_text }}
                    </span>
                    <client-only>
                    <countdown :time="checkoutCustom.stopwatch_minutes * 60 * 1000" :emit-events="false" :autoStart="true">
                        <template #default="{ hours, minutes, seconds }">
                        <span style="color: var(--stopwatch-timer-color); display: block; text-align: center; font-weight: 800;">
                            {{ String(parseInt(hours)).padStart(2, '0') }}:{{ String(minutes).padStart(2, '0') }}:{{ String(seconds).padStart(2, '0') }}
                        </span>
                        </template>
                    </countdown>
                    </client-only>
                </div>
            </div>
        </div>
        <div class="content clearfix" style="padding-top: 0px">
            <div v-if="checkoutCustom.text_header" class="holder-countdown" :style="`background: var(--stopwatch-bg-color); margin: 0px`">
            <div class="container">
                <div class="countdown-text" style="color: var(--stopwatch-txt-color) !important">
                <p v-html="checkoutCustom.text_header"></p>
                </div>
            </div>
            </div>
            <div class="container clearfix">
            <div class="row-single">
                <div class="col-single col-60 holder-cols-checkout col-resume">
                <!-- LOGO -->
                <div class="logo mt-4" v-if="this.$store.getters['getStore'].domain">
                    <a :href="`https://${this.$store.getters['getStore'].domain}`"><img :src="checkoutCustom.logo" class="img-logo" height="35" /></a>
                </div>
                <div v-else>
                    <img :src="checkoutCustom.logo" class="logo-single" />
                </div>
                <div class="box-resume" :class="{ 'opened -force-open': toggleSumary }" style="border: solid 0.5px; padding: 10px; margin: 0px; border-radius: 4px;">
                    <div class="box-title flex between js-box-resume-title" @click.prevent="toggleSumary = !toggleSumary">
                    <div class="c-text">
                        <span class="-title f18 medium">RESUMO</span>
                        <span class="items__count bold -mobile">({{ getCart.length }})</span>
                        <div class="resume-description f11 black-60 mt2 -mobile -block">Informações da sua compra {{ getStore.title }}</div>
                    </div>
                    <div>
                        <span class="cart_total -mobile mt7">
                        <span class="-total">
                            R$ {{ convertCurrency(getSumary.total_amount / 100, '', 2) }}
                        </span>
                        <i class="icon icon-arrow-left"></i>
                        </span>
                    </div>
                    </div>
                    <div class="js-box-animation box-animation">
                    <div class="box-content clearfix mt15">
                        <div class="clearfix holder-promocode" v-if="checkoutCustom.summary_configs.includes('show_coupon')">
                        <form @submit.prevent="addCoupon" id="form-promocode" class="form-promocode form-horizontal">
                            <div class="form-group w-100">
                            <div class="clearfix">
                                <label for="promocode" class="label-control block">Tem um cupom?</label>
                                <i class="block icon-promocode"></i>
                                <div class="flex">
                                <input type="text" name="code" id="promocode" v-model="coupon_code" placeholder="Código do cupom" class="input input-promocode pull-left" required />
                                <button type="submit" class="btn btn-tertiary btn-h36">Adicionar</button>
                                </div>
                                <div class="spinner-grey spinner-promocode"></div>
                            </div>
                            <div class="c-error f10 mt5 mb5 promocode-error"></div>
                            <div v-if="getSumary.amount_discount_coupon > 0" class="promocode_discount promocode_discount_applied f11 bold">
                                Desconto (- R$ {{ convertCurrency(getSumary.amount_discount_coupon / 100, '', 2) }})
                            </div>
                            <a v-if="getSumary.amount_discount_coupon > 0" href="" @click.prevent="$store.commit('removeCoupon'); coupon_code = ''" class="delete-promocode mt5 f11 inline-block ctx-c-svg medium flex hcenter">
                                <span class="ml3">Remover</span>
                            </a>
                            </div>
                        </form>
                        </div>
                        <div>
                        <div v-if="$store.getters['getCustomFormCheckouts'] && $store.getters['getCustomFormCheckouts'].length > 0">
                            <div class="form-group w-100" v-for="(item, index) in $store.getters['getCustomFormCheckouts']" :key="`customformcheckouts_${index}`">
                            <label for="customformcheckouts" class="label-control p-5">{{ item.label }}</label>
                            <input class="my-8" :type="item.type" :name="item.name" v-model="custom_form_option[index]" />
                            </div>
                        </div>
                        </div>
                        <div v-if="checkoutCustom.type_total_cart === 1" class="cart-resume mt10">
                        <div class="detail">
                            <div class="description">
                            Produtos
                            </div>
                            <div style="font-size: 15px;" class="total detail bold">R$ {{ convertCurrency(getSumary.subtotal / 100, '', 2) }}</div>
                        </div>
                        <div class="detail" v-if="getSumary.amount_discount > 0">
                            <div class="description">Descontos</div>
                            <div class="value">R$ {{ convertCurrency(getSumary.total_amount / 100, '', 2) }}</div>
                        </div>
                        <div class="detail total bold" v-if="Object.keys($store.getters['getSumary']['installments_data']).length > 1">
                            <div class="description">Total</div>
                            <div class="value js-cart-total">
                            {{ Object.keys($store.getters['getSumary']['installments_data']).length }}x de {{ applyDiscount($store.getters['getSumary']['installments_data'][Object.keys($store.getters['getSumary']['installments_data']).length].amount_installment) }}*
                            </div>
                        </div>
                        <div class="block black" style="text-align: right; font-size: 12px; color: #333333;">
                            <small v-if="paymentMethodSelected === 1" class="vezes">ou R$ {{ totalCreditCard }} à vista</small>
                            <small v-if="paymentMethodSelected === 2" class="vezes">ou R$ {{ totalBillet }} à vista</small>
                            <small v-if="paymentMethodSelected === 3" class="vezes">ou R$ {{ totalPix }} à vista</small>
                            <small v-if="!paymentMethodSelected" class="vezes">ou R$ {{ convertCurrency(getSumary.total_amount / 100, '', 2) }} à vista</small>
                        </div>
                        <div>
                            <div class="detail" v-if="getSumary.shipping >= 0 || this.$store.getters['getSetup'].forceFreeShipping === false && getSumary.exists_shipping_paid === true">
                            <div class="shipping-info" v-if="getSumary.shipping > 0">Frete</div>
                            <span v-if="getSumary.shipping > 0" class="value">R$ {{ convertCurrency(getSumary.shipping / 100, '', 2) }}</span>
                            </div>
                        </div>
                        </div>
                        <div v-else class="cart-resume mt10">
                        <div class="detail">
                            <div class="description">
                            Produtos
                            </div>
                            <div class="value">R$ {{ convertCurrency(getSumary.subtotal / 100, '', 2) }}</div>
                        </div>
                        <div class="detail" v-if="getSumary.amount_discount > 0">
                            <div class="description">Descontos</div>
                            <div class="value">R$ {{ convertCurrency(getSumary.amount_discount / 100, '', 2) }}</div>
                        </div>
                        <div>
                            <div class="detail" v-if="getSumary.shipping >= 0 || this.$store.getters['getSetup'].forceFreeShipping === false && getSumary.exists_shipping_paid === true">
                                <div class="description" v-if="getSumary.shipping > 0">Frete</div>
                                <span v-if="getSumary.shipping > 0" class="value">R$ {{ convertCurrency(getSumary.shipping / 100, '', 2) }}</span>
                            </div>
                        </div>
                        <div v-if="paymentMethodSelected === 1" class="detail total bold">
                            <div class="description">Total</div>
                            <div class="value js-cart-total">R$ {{ totalCreditCard }}</div>
                        </div>
                        <div v-if="paymentMethodSelected === 2" class="detail total bold">
                            <div class="description">Total</div>
                            <div class="value js-cart-total">R$ {{ totalBillet }}</div>
                        </div>
                        <div v-if="paymentMethodSelected === 3" class="detail total bold">
                            <div class="description">Total</div>
                            <div class="value js-cart-total">R$ {{ totalPix }}</div>
                        </div>
                        <div v-if="!paymentMethodSelected" class="detail total bold">
                            <div class="description">Total</div>
                            <div class="value js-cart-total">R$ {{ convertCurrency(getSumary.total_amount / 100, '', 2) }}</div>
                        </div>
                        <!-- <div class="block black" style="text-align: right; font-size: 12px; color: #333333;">
                            <small class="vezes">em até 12x no cartão</small>
                        </div> -->
                        </div>
                        <div class="holder-container-resume js-holder-container-resume">
                        <div v-for="(item, index) in getCart" :key="index" v-if="item.operation_type === 1" class="item-holder js-item-holder flex">
                            <div class="item-image">
                            <img :src="item.cover || 'data:image/png;base64,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'" 
                                                                         :alt="item.title || 'Imagem não disponível'" 
                                                                            class="thumb-product block" />
                            </div>
                            <div class="item-detail f12">
                            <div>
                                <div class="item-name c-text-tertiary" style="margin-bottom: 0px !important;">{{ item.title }}</div>
                                <div class="item-delete"></div>
                            </div>
                            <div class="bold c-text-secondary" v-if="item.variation_title !== 'Default Title'" style="margin-top: 0px !important;">
                                <span class="item-variation">{{ item.variation_title }}</span>
                            </div>
                            <div class="item-holder-quantity-price c-text medium" style="margin-top: 0px !important;">
                                <span class="item-price">R$ {{ convertCurrency(item.price / 100, '', 2) }}</span>
                            </div>
                            <div class="custom_options_list" v-if="customOptions">
                                <div v-for="(option, index) in customOptions" :key="index">
                                    <p v-for="(value, key) in option.options" :key="key">
                                        <strong>{{ key }}:</strong> {{ value }}
                                    </p>
                                </div>
                            </div>
                            <div v-if="item.operation_type === 1 && checkoutCustom.summary_configs.includes('enable_change_quantity')" class="item-quantity-selector-holder js-item-quantity-selector-holder">
                                <div class="relative">
                                <a v-if="typeof $route.query.lock_changes === 'undefined'" @click.prevent="$store.commit('updateQuantity', { operation: 'less', item: item })" href="javascript:" class="switch-control less">
                                    <i class="icon icon-less"></i>
                                </a>
                                <a v-if="typeof $route.query.lock_changes === 'undefined'" @click.prevent="$store.commit('updateQuantity', { operation: 'plus', item: item })" href="javascript:" class="switch-control more">
                                    <i class="icon icon-more"></i>
                                </a>
                                <input type="text" :disabled="typeof $route.query.lock_changes !== 'undefined'" class="input-quantity js-input-quantity" :value="item.quantity" />
                                </div>
                                <a @click.prevent="$store.commit('removeCartItem', item)" v-if="checkoutCustom.summary_configs.includes('enable_delete_items')" href="javascript:" class="switch-control remove">Remover</a>
                                <div class="error-item red f11 hide text-center"></div>
                            </div>
                            </div>
                        </div>
                        <div class="orderbumps-items-holder" v-if="typeof getCart !== 'undefined' && getCart.find((u) => u.operation_type === 2)">
                            <div class="orderbumps_offer-title">
                            <span class="emoji">🎉</span>
                            OFERTA ADQUIRIDA
                            </div>
                            <div v-for="(item, index) in getCart" :key="`orderbump_cart_${index}`" v-if="item.operation_type === 2" class="item-holder js-item-holder flex is-orderbump selected">
                            <div class="item-image">
                                <img :src="item.cover" class="thumb-product block" />
                            </div>
                            <div class="item-detail f12">
                                <div class="" style="margin-top: 0px !important;">
                                <div class="item-name c-text-tertiary" style="margin-bottom: 0px !important;">
                                    {{ item.title }}
                                </div>
                                <div class="item-delete"></div>
                                </div>
                                <div v-if="item.variation_title !== 'Default Title'" class="bold c-text-secondary" style="margin-top: 0px !important;">
                                <span class="item-variation">{{ item.variation_title }}</span>
                                </div>
                                <div class="item-row item-holder-quantity-price c-text medium" style="margin-top: 0px !important;">
                                    <span class="item-price">{{ item.price <= 0 ? 'Grátis' : `R$ ${convertCurrency(item.price / 100, '', 2)}` }}</span>
                                </div>
                                <div class="custom_options_list" v-if="customOptions">
                                    <div v-for="(option, index) in customOptions" :key="index">
                                        <p v-for="(value, key) in option.options" :key="key">
                                            <strong>{{ key }}:</strong> {{ value }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="item-delete text-center ml15">
                                <a href="javascript:" @click.prevent="$store.commit('removeCartItem', { cartvar: `${item.variation_hash}_2` }); orderbumpUncheck = true" class="delete-item black-30 f16 relative">
                                <i class="icon icon-trash" aria-hidden="true"></i>
                                <span class="btn-label -mobile -block bold f9 mt3 black-40">Excluir</span>
                                <span class="-desktop">
                                    <span class="tooltip2">
                                    <div class="tt-content-holder" style="width: auto;">
                                        <div class="tt-content bold text-center">
                                        <div class="tt-line">Excluir</div>
                                        </div>
                                    </div>
                                    </span>
                                </span>
                                </a>
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
                <div class="col-single col-60 holder-cols-checkout">
                <div class="logo-none">
                    <div class="logo" v-if="this.$store.getters['getStore'].domain">
                    <a :href="`https://${this.$store.getters['getStore'].domain}`">
                        <img :src="checkoutCustom.logo" class="img-logo" height="35" /></a>
                    </div>
                    <div v-else>
                    <img :src="checkoutCustom.logo" class="logo-single logo-block" />
                    </div>
                </div>
                <div :class="{ active: step === 'info' }" class="box-single box-customer" style="margin-bottom: 10px" data-next=".box-payment">
                    <div class="box-title-single">
                        <h5>Informações Pessoais</h5>
                        <h6>Para quem devemos entregar o pedido?</h6>
                    </div>
                    <div class="box-content">
                        <div class="js-customer-form-inputs">
                            <form @submit.prevent="checkValid" ref="form" novalidate id="form-customer" class="form-horizontal clearfix text-left js-form-customer form-customer" @click="$store.dispatch('callEventTracker', { event: 'clickFormFirstStep', extra_params: { store_id: $store.getters['getStore'].id, store_title: $store.getters['getStore'].title, }, })">
                                <div class="clearfix">
                                    <div class="group-f group-change">
                                    <div class="form-group w-100">
                                        <TwInputTextYampi @updateFieldsForm="updateFieldsForm" class_names="w-full md:w-1/2" ref="name" :forceValidation="forceValidation.name" type="text" name="name" :value="lead.name" var="lead" autocomplete="name" errors="Informe seu nome" label="Nome completo" :rules="{ required: true, minlenght: 5, fullNameValidate: true, }" placeholder="Ex: Maria Oliveira" />
                                    </div>
                                    <div class="form-group w-100">
                                        <TwInputTextYampi @updateFieldsForm="updateFieldsForm" class_names="w-full md:w-1/2" ref="email" :forceValidation="forceValidation.email" type="email" name="email" :value="lead.email" var="lead" autocomplete="email" errors="Informe um e-mail" label="E-mail" :rules="{ required: true, email: true, }" placeholder="Ex: maria@gmail.com" />
                                    </div>
                                    <div class="form-group w-62 keep-size" v-if="false">
                                        <label for="cpf" class="label-control block">CPF</label>
                                        <div class="holder-input valid">
                                            <input type="tel" name="cpf" id="cpf" autocomplete="cpf" class="input input-validate required minlength cpf" minlength="14" value="54215269253" placeholder="000.000.000-00/00.000.000/0000-00" maxlength="14" />
                                        </div>
                                        <div id="cpf_errors" class="error-block" style="display: none;"></div>
                                    </div>
                                    </div>
                                    <div class="form-group w-100">
                                        <TwInputTextYampi @updateFieldsForm="updateFieldsForm" class_names="w-full md:w-1/2" ref="phone_number" :forceValidation="forceValidation.phone_number" type="tel" name="phone_number" :value="lead.phone_number" var="lead" autocomplete="tel-national" :maxlenght="20" errors="Informe o número do telefone celular" label="Celular / WhatsApp" :rules="{ required: true, phone_number: true, }" :masksD="['(##) ####-####', '(##) #####-####', '(##) #####-####', ]" placeholder="(00) 00000-0000" />
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div class="box-single box-addresses" style="margin-bottom: 0px" v-if="isShowTypeProduct == 1">
                    <div class="box-title-single">
                    <h5>Informações de Entrega</h5>
                    <h6>Para onde devemos entregar o pedido?</h6>
                    </div>
                    <div class="box-content">
                    <div class="clearfix group-first mt5 w-100" style="display: flex; align-items: center;" v-if="step === 'address' || checkoutCustom.template_mode_is_single === 2">
                        <div class="form-group w-50" @click="$store.dispatch('callEventTracker', { event: 'clickFormAddress', extra_params: { store_id: $store.getters['getStore'].id, store_title: $store.getters['getStore'].title, }, })">
                            <TwInputTextYampi @updateFieldsForm="updateFieldsForm" @cep-initial-load="handleCepInitialLoad" @cep-blurred="handleCepBlurred" class_names="w-full md:w-1/2" :masksD="['########', '#####-###', ]" ref="zip_code" :forceValidation="forceValidation.zip_code" type="tel" name="zip_code" :value="lead.zip_code" var="lead" errors="Informe o CEP" label="CEP - Endereço" :rules="{ required: true, zip_code: true, }" autocomplete="postal-code" placeholder="00000-000" data-no-validate-on-input="true" :input-listener="preventCepValidation" />
                        </div>
                        <div class="form-group w-50" style="margin-top: 20px; padding-left: 20px;">
                            <div class="city-infos black-60 f13" v-if="validation.zip_code">
                                <span class="city-name" v-if="lead.city">{{ lead.city }} / </span>
                                <span class="city-uf" v-if="lead.state">{{ lead.state }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="group-form" v-if="((validation.zip_code && step === 'address') || checkoutCustom.template_mode_is_single === 2) && validation.zip_code">
                        <div class="form-group w-100">
                            <TwInputTextYampi @updateFieldsForm="updateFieldsForm" class_names="w-full md:w-1/2" ref="street_name" :forceValidation="forceValidation.street_name" type="text" name="street_name" :value="lead.street_name" var="lead" errors="Informe o nome da Rua" label="Nome da Rua" :rules="{ required: true, minlenght: 2, }" autocomplete="shipping address-line1" placeholder="Rua, Estrada, etc.." />
                        </div>
                        <div class="form-group w-100 keep-size -padding-right">
                            <TwInputTextYampi @updateFieldsForm="updateFieldsForm" class_names="w-full md:w-1/2" ref="number" :forceValidation="forceValidation.number" type="text" name="number" :value="lead.number" var="lead" errors="Informe o número" label="Número" :rules="{ required: true, }" autocomplete="shipping address-line2" placeholder="Número da Casa, APTO, etc.." />
                        </div>
                        <div class="form-group w-100">
                            <TwInputTextYampi @updateFieldsForm="updateFieldsForm" class_names="w-full md:w-1/2" ref="complement" :forceValidation="forceValidation.complement" type="text" name="complement" :value="lead.complement" var="lead" errors="" label="Complemento" rules="" autocomplete="shipping address-level4" placeholder="Complemento do Endereço" />
                        </div>
                        <div class="form-group w-100 keep-size -padding-left">
                            <TwInputTextYampi @updateFieldsForm="updateFieldsForm" class_names="w-full md:w-1/2" ref="neighborhood" :forceValidation="forceValidation.neighborhood" type="text" name="neighborhood" :value="lead.neighborhood" var="lead" errors="Bairro" label="Bairro" :rules="{ required: true, }" autocomplete="shipping address-level3" placeholder="Bairro" />
                        </div>
                        <div class="form-group w-80 keep-size -padding-left" v-show="!lead.city">
                            <TwInputTextYampi @updateFieldsForm="updateFieldsForm" class_names="w-full md:w-1/2" ref="city" :forceValidation="forceValidation.city" type="text" name="city" :value="lead.city" var="lead" errors="Cidade" label="Cidade" :rules="{ required: true, }" autocomplete="shipping address-level2" placeholder="Cidade" />
                        </div>
                        <div class="form-group w-20 keep-size -padding-left" v-show="!lead.state">
                            <TwInputTextYampi @updateFieldsForm="updateFieldsForm" class_names="w-full md:w-1/2" ref="state" :forceValidation="forceValidation.state" type="select" name="state" :value="lead.state" var="lead" errors="Estado" label="Estado" :rules="{ required: true, }" autocomplete="state" placeholder="Estado" :select_values="statesBrazil" />
                        </div>
                        <div class="form-group w-100" style="margin-top: 10px" v-if="checkoutCustom.template_mode_is_single === 0">
                            <button type="submit" class="btn btn-primary btn-block btn-send" @click="() => { checkValid(); if (checkAddressValidMethod()) { step = 'address-2' } }">Salvar</button>
                        </div>
                    </div>
                    </div>
                    <div class="container-addresses mt-5" v-if="checkAddressValid && (step === 'address-2' || checkoutCustom.template_mode_is_single === 0)" style="margin-top: 15px">
                    <div class="box-address">
                        <label for="address-133135216" class="inner-box holder-icheck" v-if="checkoutCustom.template_mode_is_single === 0">
                        <div class="iradio_minimal checked" style="position: relative;">
                            <input type="radio" name="address" id="address-133135216" class="input-icheck select-customer-address" style="position: absolute; visibility: hidden;" />
                            <ins class="iCheck-helper" style="position: absolute; top: 0%; left: 0%; display: block; width: 100%; height: 100%; margin: 0px; padding: 0px; background: rgb(255, 255, 255); border: 0px; opacity: 0;"></ins>
                        </div>
                        <span class="inner-label black-80 f11">
                            <span class="medium block">{{ lead.street_name }}, {{ lead.number }} - {{ lead.neighborhood }}</span>
                            <br />
                            {{ lead.city }}-{{ lead.state }} | CEP <span class="zipcode">{{ lead.zip_code }}</span>
                        </span>
                        </label>
                        <a href="javascript:" @click.prevent="step = 'address'" class="btn-edit-address f12 black-40 text-center" v-if="checkoutCustom.template_mode_is_single === 0">
                        <span class="icon icon-pencil"></span>
                        <span class="btn-label -mobile -block bold f9 mt4 black-40">Editar</span>
                        <span class="-desktop">
                            <span class="tooltip2">
                            <div class="tt-content-holder" style="width: auto;">
                                <div class="tt-content bold text-center">
                                <div class="tt-line">Editar</div>
                                </div>
                            </div>
                            </span>
                        </span>
                        </a>
                    </div>
                    </div>
                </div>
                <div class="box-single">
                    <div class="container-shipment" v-if="$store.getters['getLogisticsShippings'].length > 0 && $store.getters['getSetup'].forceFreeShipping === false && lead.zip_code && lead.zip_code.trim() !== '' && lead.zip_code !== '00000-000' && lead.zip_code !== '00000000'">
                    <hr />
                    <div class="black-80 mt15 mb15">Escolha uma forma de entrega:</div>
                    <div class="shipment-options">
                        <div v-for="(item, index) in $store.getters['getLogisticsShippings']" :key="`shippings_${index}`">
                        <div v-if="item.custom_by_state === 1">
                            <label v-if="JSON.parse(item.states).includes(lead.state)" @click.prevent="setShippingSelected(item)" for="shipment-m-1" class="option clearfix">
                            <div class="iradio_minimal" :class="{ checked: shippingSelected === item.id }" style="position: relative;">
                                <input type="radio" name="shipment-service" class="input-icheck select-shipment-service" :value="item.id" style="position: absolute; visibility: hidden;" />
                                <ins class="iCheck-helper" style="position: absolute; top: 0%; left: 0%; display: block; width: 100%; height: 100%; margin: 0px; padding: 0px; background: rgb(255, 255, 255); border: 0px; opacity: 0;"></ins>
                            </div>
                            <div class="inner-label">
                                <div class="text pull-left black-80 f12">
                                <span class="medium block">{{ item.title }}</span>
                                <span class="shipping-time" v-if="item.description">{{ item.description }}</span>
                                <span class="shipping-time" v-else>Entrega Garantida</span>
                                </div>
                                <div v-if="item.price == 0" class="price pull-right f12 bold">Grátis</div>
                                <div v-else class="price pull-right f12 bold">R$ {{ convertCurrency(item.price / 100) }}</div>
                                <div v-if="item.delivery_time !== null && item.delivery_time !== 0" class="price pull-left f12 bold">Entrega em {{ item.delivery_time }} dias</div>
                            </div>
                            </label>
                        </div>
                        <div v-else>
                            <label @click.prevent="setShippingSelected(item)" for="shipment-m-1" class="option clearfix">
                            <div class="iradio_minimal" :class="{ checked: shippingSelected === item.id }" style="position: relative;">
                                <input type="radio" name="shipment-service" class="input-icheck select-shipment-service" :value="item.id" style="position: absolute; visibility: hidden;" />
                                <ins class="iCheck-helper" style="position: absolute; top: 0%; left: 0%; display: block; width: 100%; height: 100%; margin: 0px; padding: 0px; background: rgb(255, 255, 255); border: 0px; opacity: 0;"></ins>
                            </div>
                            <div class="inner-label flex">
                                <div class="text pull-left black-80 f12">
                                <span class="medium block">{{ item.title }}</span>
                                <span class="shipping-time" v-if="item.description">{{ item.description }}</span>
                                <span class="shipping-time" v-else>Entrega Garantida</span>
                                </div>
                                <div class=" ">
                                <div v-if="item.price == 0" class="price pull-right f12 bold">Grátis</div>
                                <div v-else class="price pull-right f12 bold">R$ {{ convertCurrency(item.price / 100) }}</div>
                                <div v-if="item.delivery_time !== null && item.delivery_time !== 0" class="price pull-right f12 bold mr10">Entrega em {{ item.delivery_time }} dias </div>
                                </div>
                            </div>
                            </label>
                        </div>
                        <label v-if="shippingSelectedRequired" class="option clearfix" style="background-color: lightcoral; border-color: red; color: white;">
                            <div>Selecione uma opção de entrega</div>
                        </label>
                        </div>
                    </div>
                    <div v-if="checkoutCustom.logistics_text" v-html="checkoutCustom.logistics_text"></div>
                    </div>
                    <div class="mt25" v-if="product?.product?.tangible === 0">
                    <button type="submit" @click.prevent="checkShippingSelected()" class="btn btn-primary btn-block btn-send link-box-checkout">Continuar</button>
                    </div>
                </div>
                <div class="box-single box-payment" :class="{ active: step === 'payment' || checkoutCustom.template_mode_is_single === 1 }" data-target=".box-payment">
                    <div v-if="checkoutCustom.announcement_text_status === '1'" v-html="checkoutCustom.announcement_text" class="announcement-text">
                    </div>
                    <div class="box-title-single">
                    <h5>Método de pagamento</h5>
                    <h6>Escolha o seu método de pagamento abaixo</h6>
                    </div>
                    <div class="box-content">
                    <div class="payments">
                        <!-- PAGAMENTO VIA CARTÃO -->
                        <div class="payment payment-trigger credit-card box-0 mt15" :class="{ selected: paymentMethodSelected === 1 }" @click.prevent="payment_method = 1">
                            <label for="payment-credit-card" class="payment-header block clearfix"
                                   @click.prevent="callTrackerEvent('AddPaymentInfo', { payment_method: 'credit_card', email: lead.email })">
                                <div style="margin-bottom: 8px;">
                                    <div class="pull-right"
                                         style="display: block; text-align: center; position: absolute; right: 0; top: 3px;">
                                        <div class="discount-flag bold f10"
                                             style="position: relative;"
                                             v-if="this.$store.getters['getStore'].discount_creditcard > 0">
                                            {{ this.$store.getters['getStore'].discount_creditcard
                                            }}% DE DESCONTO <br> <span v-if="this.$store.getters['getStore'].discount_sum_with_coupons === 0"> NÃO ACUMULATIVO.</span>
                                        </div>
                                        <div v-if="checkoutCustom.payment_methods_configs.includes('show_imediate_approve')"
                                             class="bold f10 discount-flag"
                                             style="position: relative; margin-left: 2px; margin-top: 4px; margin-bottom: 3px;">
                                            APROVAÇÃO IMEDIATA</div>
                                    </div>
                                </div>
                                <div class="holder-icheck pull-left">
                                    <div class="iradio_minimal"
                                         :class="{ checked: paymentMethodSelected === 1 }"
                                         style="position: relative;">
                                        <input type="radio" id="payment-credit-card"
                                               name="payment-type"
                                               style="position: absolute; visibility: hidden;" />
                                    </div>
                                    <label for="payment-credit-card"
                                           class="holder-label medium f12 black-80 label-credit-card block">Cartão
                                        de crédito
                                        <div class="card-brands-payment cards"
                                             style="margin-top: 20px;">
                                            <img v-for="(card, index) in cards" :key="index"
                                                 :src="card.src" height="20" :alt="card.alt"
                                                 class="card-icon" />
                                        </div>
                                    </label>
                                </div>
                            </label>
                        <div class="payment-content payment-content-creditcard clearfix">
                            <div class="inner-form">
                            <div id="creditcard-single" class="creditcard-content">
                                <div id="creditcard-container-1" class="creditcard-container clearfix active" data-index="0" @click="$store.dispatch('callEventTracker', { event: 'clickFormPayment', extra_params: { form: 'creditcard', store_id: $store.getters['getStore'].id, store_title: $store.getters['getStore'].title, } })">
                                <div class="form-group w-100">
                                    <TwInputTextYampi @updateFieldsForm="updateFieldsForm" class_names="w-full md:w-1/2" :value="payment.card_number" var="payment" ref="card_number" :forceValidation="forceValidation.card_number" type="tel" name="card_number" errors="Número do cartão de crédito" label="Cartão de Crédito" :rules="{ required: true, minlenght: 8, validateCardNumberNew: true }" :maxlenght="21" :masksD="['#### #### #### ####', '#### ###### ######', '#### ###### ####']" placeholder="0000 0000 0000 0000" />
                                </div>
                                <div class="form-group w-50 keep-size -padding-right">
                                    <TwInputTextYampi v-model="payment.card_expiration" @updateFieldsForm="updateFieldsForm" class_names="w-full md:w-1/2" :masksD="['##/##']" :masked="true" var="payment" ref="card_expiration" type="tel" name="card_expiration" errors="Mês e Ano do Cartão Iválido" label="Mês e Ano do Cartão" placeholder="MM/AA" :rules="{required: true, validateExpirationDate: true}" />
                                </div>
                                <div class="form-group w-50 keep-size -padding-left">
                                    <TwInputTextYampi @updateFieldsForm="updateFieldsForm" class_names="w-full md:w-1/2" :masksD="['###', '####']" ref="card_cvv" :value="payment.card_cvv" var="payment" type="tel" name="card_cvv" errors="Código de Segurança do Cartão" label="Código CVV" :forceValidation="forceValidation.card_cvv" :rules="{ required: true, minlenght: 3 }" :minlenght="3" placeholder="***" />
                                </div>
                                <div class="form-group w-100" v-show="false">
                                    <TwInputTextYampi @updateFieldsForm="updateFieldsForm" class_names="w-full md:w-1/2" :value="lead.name" var="payment" ref="card_holdername" type="text" name="card_holdername" errors="Nome do titular do cartão" label="Nome do titular do cartão" :rules="{ required: true, minlenght: 5 }" placeholder="EX: F DA SILVA" class="hidden" />
                                </div>
                                <div class="form-group w-100" v-if="paymentMethodSelected === 1">
                                    <TwInputTextYampi @updateFieldsForm="updateFieldsForm" class_names="w-full md:w-1/2" :masksD="['###.###.###-##','##.###.###/####-##']" ref="cpf" :forceValidation="forceValidation.number" type="tel" name="cpf" :value="lead.cpf" var="lead" errors="Informe o CPF" label="CPF ou CNPJ" :rules="{ required: true, document: true }" placeholder="000.000.000-00/00.000.000/0000-00" />
                                </div>
                                <div class="form-group form-group-installments w-100" style="margin-top: 10px;">
                                    <label for="installments" class="block text-sm font-medium text-gray-700">Selecione a parcela desejada</label>
                                    <select v-if="typeof $store.getters['getSumary']['installments_data'][1] !== 'undefined'" id="installments" name="installments" ref="installments" class="mt-1 block w-full rounded-md border-gray-300 py-2 pl-3 border-2 pr-10 text-base focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm" @change="$store.commit('setInstallments', $event.target.value)">
                                    <option v-for="(item, indice) in $store.getters['getSumary']['installments_data']" :key="indice" :value="indice" :selected="$store.getters['getSumary'].installments == indice">
                                        {{ indice }}x {{ applyDiscount(item.amount_installment) + (indice <= $store.getters['getSumary'].free_installments ? ' Sem Juros' : '') }}{{ indice > $store.getters['getSumary'].free_installments ? '*' : '' }}
                                    </option>
                                    </select>
                                    <select disabled v-else class="mt-1 block w-full rounded-md border-gray-300 py-2 pl-3 border-2 pr-10 text-base focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm">
                                    <option>Preencha o cartão</option>
                                    </select>
                                </div>
                                </div>
                            </div>
                            </div>
                            <Orderbumps v-if="paymentMethodSelected === 1" :getOrderBumps="getOrderBumps" :orderbumpUncheck="orderbumpUncheck" />
                            <div class="mt10 holder-buy-button">
                            <button type="submit" class="btn btn-primary btn-block btn-send btn-finalize with-icon" @click.prevent="isClickSubmitButton = true; checkValid()" :disabled="submitting" ref="submit">Comprar agora</button>
                            </div>
                        </div>
                        </div>
                        <!-- PAGAMENTO VIA PIX -->
                        <div v-if="checkoutCustom.payment_methods.includes('3')" class="payment payment-trigger pix box-9" style="padding-bottom: 14px" :class="{ selected: paymentMethodSelected === 3 }" @click.prevent="payment_method = 3">
                            <label for="payment-pix" class="payment-header block clearfix"
                                   @click.prevent="callTrackerEvent('AddPaymentInfo', { payment_method: 'pix', email: lead.email })">
                                <div class="pull-right"
                                     style="display: block; text-align: center; position: absolute; right: 0; top: 3px;">
                                    <div class="discount-flag bold f10 mb4"
                                         style="position: relative;"
                                         v-if="this.$store.getters['getStore'].discount_pix > 0">
                                        {{ this.$store.getters['getStore'].discount_pix }}% DE
                                        DESCONTO <br> <span v-if="this.$store.getters['getStore'].discount_sum_with_coupons === 0"> NÃO ACUMULATIVO.</span>
                                    </div>
                                    <div v-if="checkoutCustom.payment_methods_configs.includes('show_imediate_approve')"
                                         class="bold f10 discount-flag"
                                         style="position: relative; margin-left: 2px; margin-top: 1px;">
                                        APROVAÇÃO IMEDIATA</div>
                                </div>
                                <div class="holder-icheck pull-left">
                                    <div class="iradio_minimal"
                                         :class="{ checked: paymentMethodSelected === 3 }"
                                         style="position: relative;">
                                        <input type="radio" id="payment-pix" name="payment-type"
                                               style="position: absolute; visibility: hidden;" /><ins
                                        class="iCheck-helper"
                                        style="position: absolute; top: 0%; left: 0%; display: block; width: 100%; height: 100%; margin: 0px; padding: 0px; background: rgb(255, 255, 255); border: 0px; opacity: 0;"></ins>
                                    </div>
                                    <label for="payment-pix"
                                           class="holder-label medium f12 black-80"><i
                                        class="icon icon-pix mr3"></i>Pix</label>
                                </div>
                            </label>
                        <div class="payment-content">
                            <div class="pix-desc mt5 mb20 medium f13 black-80">
                            <p>A confirmação de pagamento é realizada em poucos minutos. Utilize o aplicativo do seu banco para pagar.</p>
                            </div>
                            <div class="form-group w-100" style="margin-bottom: 10px;" v-if="paymentMethodSelected === 3" @click="$store.dispatch('callEventTracker', { event: 'clickFormPayment', extra_params: { form: 'pix', store_id: $store.getters['getStore'].id, store_title: $store.getters['getStore'].title }, })">
                            <TwInputTextYampi @updateFieldsForm="updateFieldsForm" class_names="w-full md:w-1/2" :masksD="['###.###.###-##','##.###.###/####-##']" ref="cpf" :forceValidation="forceValidation.number" type="tel" name="cpf" :value="lead.cpf" var="lead" errors="Informe o CPF" label="CPF ou CNPJ" :rules="{ required: true, document: true }" placeholder="000.000.000-00/00.000.000/0000-00" />
                            </div>
                            <div class="pix-price f16 bold mb10">
                                <div>
                                    <span class="cart-total js-cart-total">Valor no Pix: {{
                                            convertCurrency(getSumary.total_amount / 100, '', 2)
                                        }}</span>
                                </div>
                            </div>
                            <Orderbumps v-if="paymentMethodSelected === 3" :getOrderBumps="getOrderBumps" :orderbumpUncheck="orderbumpUncheck" />
                            <div class="mt20">
                            <button type="submit" class="btn btn-primary btn-block btn-send btn-finalize with-icon" @click.prevent="isClickSubmitButton = true; checkValid()" :disabled="submitting" ref="submit" id="pay_btn">Comprar agora</button>
                            </div>
                        </div>
                        </div>
                        <!-- BOLETO BANCÁRIO -->
                        <div v-if="checkoutCustom.payment_methods.includes('2')" class="payment payment-trigger billet box-9" :class="{ selected: paymentMethodSelected === 2 }" @click.prevent="payment_method = 2">
                            <label for="payment-billet" class="payment-header block clearfix"
                                   @click.prevent="callTrackerEvent('AddPaymentInfo', { payment_method: 'billet', email: lead.email })">

                                <div style="margin-bottom: 8px;">
                                    <div class="pull-right"
                                         style="display: block; text-align: center; position: absolute; right: 0; top: 3px;">
                                        <div class="discount-flag bold f10"
                                             style="position: relative;"
                                             v-if="this.$store.getters['getStore'].discount_billet > 0">
                                            {{ this.$store.getters['getStore'].discount_billet
                                            }}% DE DESCONTO <br> <span v-if="this.$store.getters['getStore'].discount_sum_with_coupons === 0"> NÃO ACUMULATIVO.</span>
                                        </div>
                                        <div v-if="checkoutCustom.payment_methods_configs.includes('show_imediate_approve')"
                                             class="bold f10 discount-flag"
                                             style="position: relative; margin-left: 2px; margin-top: 4px; margin-bottom: 3px;">
                                            APROVAÇÃO EM 3 DIAS</div>
                                    </div>
                                </div>
                                <div class="holder-icheck pull-left">
                                    <div class="iradio_minimal"
                                         :class="{ checked: paymentMethodSelected === 2 }"
                                         style="position: relative;">
                                        <input type="radio" id="payment-billet" name="payment-type"
                                               style="position: absolute; visibility: hidden;" />
                                        <ins class="iCheck-helper"
                                             style="position: absolute; top: 0%; left: 0%; display: block; width: 100%; height: 100%; margin: 0px; padding: 0px; background: rgb(255, 255, 255); border: 0px; opacity: 0;"></ins>
                                    </div>
                                    <label for="payment-billet"
                                           class="holder-label medium f12 black-80"><i
                                        class="icon icon-billet mr3"></i>Boleto bancário</label>
                                </div>
                            </label>
                        <div class="payment-content">
                            <div class="pix-desc mt5 mb20 medium f13 black-80">
                            <p>Somente quando recebermos a confirmação, em até 48h após o pagamento, seguiremos com o envio das suas compras. O prazo de entrega passa a ser contado somente após a confirmação do pagamento.</p>
                            </div>
                            <div class="form-group w-100" style="margin-bottom: 10px;" v-if="paymentMethodSelected === 2" @click="$store.dispatch('callEventTracker', { event: 'clickFormPayment', extra_params: { form: 'billet', store_id: $store.getters['getStore'].id, store_title: $store.getters['getStore'].title } })">
                            <TwInputTextYampi @updateFieldsForm="updateFieldsForm" class_names="w-full md:w-1/2" :masksD="['###.###.###-##','##.###.###/####-##']" ref="cpf" :forceValidation="forceValidation.number" type="tel" name="cpf" :value="lead.cpf" var="lead" errors="Informe o CPF" label="CPF ou CNPJ" :rules="{ required: true, document: true }" placeholder="000.000.000-00/00.000.000/0000-00" />
                            </div>
                            <div class="pix-price f16 bold mb10">
                                <div>
                                    <span class="cart-total js-cart-total">Valor no Boleto: {{
                                            convertCurrency(getSumary.total_amount / 100, '', 2)
                                        }}</span>
                                </div>
                            </div>
                            <Orderbumps v-if="paymentMethodSelected === 2" :getOrderBumps="getOrderBumps" :orderbumpUncheck="orderbumpUncheck" />
                            <div class="mt20">
                            <button type="submit" class="btn btn-primary btn-block btn-send btn-finalize with-icon" @click.prevent="isClickSubmitButton = true; checkValid()" :disabled="submitting" ref="submit" id="pay_btn">Comprar agora</button>
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
                <div class="col-resume">
                    <div class="col-single" v-if="$store.getters['getTestimonials'] && $store.getters['getTestimonials'].length > 0" style="margin-top: 20px">
                    <div class="container-testimonials">
                        <div class="testimonials">
                        <div class="box-testimonial clearfix" v-for="(item, index) in $store.getters['getTestimonials']" :key="`testimonials_${index}`">
                            <div class="box-testimonial__photo pull-left ml20">
                            <img :src="item.image || 'data:image/png;base64,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'" 
                                    alt="Satisfação ou seu valor de volta" 
                                    class="photo" />
                            </div>
                            <div class="box-testimonial__infos pull-left ml15">
                            <div class="infos__rating mt5 mb5">
                                <i class="fa fa-star yellow mr-2" v-for="index in item.stars" :key="`start_${index}`"></i>
                            </div>
                            <strong class="infos__name black-60">{{ item.title }}</strong>
                            <p class="infos__text black-60" v-html="item.description"></p>
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
                <Footer :checkoutCustom="checkoutCustom" :storeData="getStore"></Footer>
                </div>
                <Payment v-if="checkFirstStepValid" :submitting="submitting" :payment_method="paymentMethodSelected" @callbackSubmit="callbackSubmit" />
                <div class="col-single col-40 holder-cols-checkout">
                <!-- PARA ABRIR ADICIONAR AS CLASSES: opened -force-open -->
                <div class="box-resume" :class="{ 'opened -force-open': toggleSumary }">
                    <div class="box-title flex between js-box-resume-title" @click.prevent="toggleSumary = !toggleSumary">
                    <div class="c-text">
                        <span class="-title f18 medium">RESUMO</span>
                        <span class="items__count bold -mobile">({{ getCart.length }})</span>
                        <div class="resume-description f11 black-60 mt2 -mobile -block">
                        Informações da sua compra {{ getStore.title }}
                        </div>
                    </div>
                    <div>
                        <span class="cart_total -mobile mt7">
                        <span class="-total">R$ {{ convertCurrency(getSumary.total_amount / 100, '', 2) }}</span>
                        <i class="icon icon-arrow-left"></i>
                        </span>
                    </div>
                    </div>
                    <div class="js-box-animation box-animation">
                    <div class="box-content clearfix mt15">
                        <div class="clearfix holder-promocode" v-if="checkoutCustom.summary_configs.includes('show_coupon')">
                        <form @submit.prevent="addCoupon" id="form-promocode" class="form-promocode form-horizontal">
                            <div class="form-group w-100">
                            <div class="clearfix">
                                <label for="promocode" class="label-control block">Tem um cupom?</label>
                                <i class="block icon-promocode"></i>
                                <div class="flex">
                                <input type="text" name="code" id="promocode" v-model="coupon_code" placeholder="Código do cupom" class="input input-promocode pull-left" required />
                                <button type="submit" class="btn btn-tertiary btn-h36">Adicionar</button>
                                </div>
                                <div class="spinner-grey spinner-promocode"></div>
                            </div>
                            <div class="c-error f10 mt5 mb5 promocode-error"></div>
                            <div v-if="getSumary.amount_discount_coupon > 0" class="promocode_discount promocode_discount_applied f11 bold">
                                Desconto (- R$ {{ convertCurrency(getSumary.amount_discount_coupon / 100, '', 2) }})
                            </div>
                            <a v-if="getSumary.amount_discount_coupon > 0" href="" @click.prevent="$store.commit('removeCoupon'); coupon_code = ''" class="delete-promocode mt5 f11 inline-block ctx-c-svg medium flex hcenter">
                                <span class="ml3">Remover</span>
                            </a>
                            </div>
                        </form>
                        </div>
                        <div>
                        <div v-if="$store.getters['getCustomFormCheckouts'] && $store.getters['getCustomFormCheckouts'].length > 0">
                            <div class="form-group w-100" v-for="(item, index) in $store.getters['getCustomFormCheckouts']" :key="`customformcheckouts_${index}`">
                            <label for="customformcheckouts" class="label-control p-5">{{ item.label }}</label>
                            <input class="my-8" :type="item.type" :name="item.name" v-model="custom_form_option[index]" />
                            </div>
                        </div>
                        </div>
                        <div class="cart-resume mt10">
                        <div class="detail">
                            <div class="description">Produtos</div>
                            <div class="value">{{ convertCurrency(getSumary.subtotal / 100, '', 2) }}</div>
                        </div>
                        <div class="detail" v-if="getSumary.amount_discount > 0">
                            <div class="description">Descontos</div>
                            <div class="value">{{ convertCurrency(getSumary.amount_discount / 100, '', 2) }}</div>
                        </div>
                        <div>
                            <div class="detail" v-if="getSumary.shipping > 0 || this.$store.getters['getSetup'].forceFreeShipping === false && getSumary.exists_shipping_paid === true">
                                <div class="description" v-if="getSumary.shipping > 0">Frete</div>
                                <span v-if="getSumary.shipping > 0" class="value">R$ {{ convertCurrency(getSumary.shipping / 100, '', 2) }}</span>
                            </div>
                            <div class="shipping-info tag-free-shipping" v-else>
                                <div style="padding-left: 4px;">Frete grátis</div>
                            </div>
                        </div>
                        <div class="detail total bold">
                            <div class="description">Total</div>
                            <div class="value js-cart-total">R$ {{ convertCurrency(getSumary.total_amount / 100, '', 2) }}</div>
                        </div>
                        <div class="block black" style="text-align: right; font-size: 12px; color: #333333;">
                            <small>em até 12x no cartão</small>
                        </div>
                        </div>
                        <div class="holder-container-resume js-holder-container-resume">
                        <div v-for="(item, index) in getCart" :key="index" v-if="item.operation_type === 1" class="item-holder js-item-holder flex">
                            <div class="item-image">
                                <img :src="item.cover || 'data:image/png;base64,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'" 
                                    :alt="item.title || 'Imagem não disponível'" 
                                    class="thumb-product block" />
                            </div>
                            <div class="item-detail f12">
                            <div>
                                <div class="item-name c-text-tertiary" style="margin-bottom: 0px !important;">{{ item.title }}</div>
                                <div class="item-delete"></div>
                            </div>
                            <div class="bold c-text-secondary" v-if="item.variation_title !== 'Default Title'" style="margin-top: 0px !important;">
                                <span class="item-variation">{{ item.variation_title }}</span>
                            </div>
                            <div class="item-holder-quantity-price c-text medium" style="margin-top: 0px !important;">
                                <span class="item-price">R$ {{ convertCurrency(item.price / 100, '', 2) }}</span>
                            </div>
                                <div>
                                    <div class="custom_options_list" v-for="(value, key) in item.custom_options" :key="key" style="margin: 5px 0; font-size: 14px;">
                                        <div v-for="(v, k) in value"  style="margin: 5px 0; font-size: 14px;">
                                            <span v-if='k !== "quantity"'><strong>{{k }}:</strong> {{ v }}</span>
                                        </div>
                                        <div style="margin: 5px 0; font-size: 14px;">
                                            <span ><strong>Quantidade:</strong> {{ item.quantity }}</span>
                                        </div>
                                    </div>
                                </div>
                            <div v-if="item.operation_type === 1 && checkoutCustom.summary_configs.includes('enable_change_quantity')" class="item-quantity-selector-holder js-item-quantity-selector-holder">
                                <div class="relative">
                                <a v-if="typeof $route.query.lock_changes === 'undefined'" @click.prevent="$store.commit('updateQuantity', { operation: 'less', item: item })" href="javascript:" class="switch-control less">
                                    <i class="icon icon-less"></i>
                                </a>
                                <a v-if="typeof $route.query.lock_changes === 'undefined'" @click.prevent="$store.commit('updateQuantity', { operation: 'plus', item: item })" href="javascript:" class="switch-control more">
                                    <i class="icon icon-more"></i>
                                </a>
                                <input type="text" :disabled="typeof $route.query.lock_changes !== 'undefined'" class="input-quantity js-input-quantity" :value="item.quantity" />
                                </div>
                                <a @click.prevent="$store.commit('removeCartItem', item)" v-if="checkoutCustom.summary_configs.includes('enable_delete_items')" href="javascript:" class="switch-control remove">Remover</a>
                                <div class="error-item red f11 hide text-center"></div>
                            </div>
                            </div>
                        </div>
                        <div class="orderbumps-items-holder" v-if="typeof getCart !== 'undefined' && getCart.find((u) => u.operation_type === 2)">
                            <div class="orderbumps_offer-title">
                            <span class="emoji">🎉</span>OFERTA ADQUIRIDA
                            </div>
                            <div v-for="(item, index) in getCart" :key="`orderbump_cart_${index}`" v-if="item.operation_type === 2" class="item-holder js-item-holder flex is-orderbump selected">
                            <div class="item-image">
                                <img :src="item.cover" class="thumb-product block" />
                            </div>
                            <div class="item-detail f12">
                                <div class="" style="margin-top: 0px !important;">
                                <div class="item-name c-text-tertiary" style="margin-bottom: 0px !important; text-align: center;">{{ item.title }}</div>
                                <div class="item-delete"></div>
                                </div>
                                <div v-if="item.variation_title !== 'Default Title'" class="bold c-text-secondary" style="margin-top: 0px !important;">
                                <span class="item-variation">{{ item.variation_title }}</span>
                                </div>
                                <div class="item-row item-holder-quantity-price c-text medium" style="margin-top: 0px !important;">
                                    <span class="item-price">{{ item.price <= 0 ? 'Grátis' : `R$ ${convertCurrency(item.price / 100, '', 2)}` }}</span>
                                </div>
                                <div class="custom_options_list" v-if="customOptions">
                                    <div v-for="(option, index) in customOptions" :key="index">
                                        <p v-for="(value, key) in option.options" :key="key">
                                            <strong>{{ key }}:</strong> {{ value }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="item-delete text-center ml15">
                                <a href="javascript:" @click.prevent="$store.commit('removeCartItem', { cartvar: `${item.variation_hash}_2` }); orderbumpUncheck = true" class="delete-item black-30 f16 relative">
                                <i class="icon icon-trash" aria-hidden="true"></i>
                                <span class="btn-label -mobile -block bold f9 mt3 black-40">Excluir</span>
                                <span class="-desktop">
                                    <span class="tooltip2">
                                    <div class="tt-content-holder" style="width: auto;">
                                        <div class="tt-content bold text-center">
                                        <div class="tt-line">Excluir</div>
                                        </div>
                                    </div>
                                    </span>
                                </span>
                                </a>
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
                <div class="col-resume-2">
                    <div class="col-single" v-if="$store.getters['getTestimonials'] && $store.getters['getTestimonials'].length > 0" style="margin-top: 20px">
                    <div class="container-testimonials">
                        <div class="testimonials">
                        <div class="box-testimonial clearfix" v-for="(item, index) in $store.getters['getTestimonials']" :key="`testimonials_${index}`">
                            <div class="box-testimonial__photo pull-left ml20">
                            <img :src="item.image || 'data:image/png;base64,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'" 
                                    alt="Satisfação ou seu valor de volta" 
                                    class="photo" />
                            </div>
                            <div class="box-testimonial__infos pull-left ml15">
                            <div class="infos__rating mt5 mb5">
                                <i class="fa fa-star yellow mr-2" v-for="index in item.stars" :key="`start_${index}`"></i>
                            </div>
                            <strong class="infos__name black-60">{{ item.title }}</strong>
                            <p class="infos__text black-60" v-html="item.description"></p>
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </div>
        </div>
        <div v-if="false" id="modal-transaction-error" class="modal overlay overlay-transaction-error" style="display: block">
        <div class="inner-modal">
            <div class="align-middle black-60">
            <div class="modal-content text-center">
                <div class="inner-content">
                <div class="t1 mt10 mb20 bold red f-h2">
                    😢 Ops, temos um problema
                </div>
                <p class="f16">
                    Infelizmente o seu pedido não foi aprovado
                </p>
                <div class="alert alert-warning mt15">
                    <span class="error-card bold block mb10">Cartão nº 5545********6832</span>
                    <span class="error-message">Transação não permitida</span>
                    <span class="block mt5">Código do erro: <span class="error-code">5</span></span>
                </div>
                <a href="javascript:" class="btn btn-grey btn-block mt15 mb15 close-transaction-error">tentar novamente</a>
                </div>
                <p class="f11 tip js-tip" style="display: block;">
                <span class="bold">Dica:</span>
                <span class="js-creditcard-tip" style="display: inline;">A maioria das compras negadas usando cartão são devidas a erro de digitação dos dados. Verifique os dados do cartão e tente novamente.</span>
                <span class="js-nupay-tip" style="display: none;">Pode ser que o pagamento não tenha sido aprovado por você não ter uma conta no Nubank, caso você tenha conta verifique seu saldo e limite e tente novamente.</span>
                </p>
                <a href="#" class="modal-close" data-target="modal-transaction-error">[x] fechar</a>
            </div>
            </div>
        </div>
        </div>
        </div>
        </div>
    </div>
</template>


<style lang="scss">
    @import url('https://fonts.googleapis.com/css2?family=Rubik:wght@400;500;700&amp;display=swap');
    @import url('~/assets/css/fa.css');
    @import url('~/assets/css/app.css');



    button {
        margin-top: 10px;
        margin-bottom: 10px;
    }

    .discount-flag-one{
        background-color: #c935ee;
        padding: 5px;
        border-radius: 5px;
        margin: 5px;
        color: #fff;
    }

    .holder-cols-checkout .container-shipment .option .inner-label .text {
        width: auto !important;
    }

    .box-title-single h5{
        font-size: 16px;
        font-weight: bold;
    }

    .box-title-single h4{
        font-size: 12px;
    }

    .col-single {
    padding-right: 15px;
    padding-left: 15px;
    }

    .col-60 {
    flex: 0 0 60%;
    max-width: 60%;
    background: #ffffff;
    padding: 10px;
    }

    .col-40 {
    flex: 0 0 40%;
    max-width: 40%;
    background: #ffffff;
    border-left: 1.3px solid rgb(181, 181, 181);
    }

    .logo-block{
        display: block;
    }

    .logo {
        padding-left: 15px;
    }

    .logo-single{
        width: 150px;
        padding: 10px;
    }

    .clearfix{
        margin-bottom: 0px;
        padding-bottom: 0px;
    }

    .col-resume{
        display: none;
    }

    .col-resume-2{
        display: block;
    }

    .row-single{
        display: flex;
    }

    .box-single{
        background: #ffffff;
        padding: 20px;
    }

    .box-resume{
        margin: 20px;
    }

    .footer-block{
        display: none;
    }

    @media (max-width: 768px) {
        .logo {
            padding-left: 8px;
            margin-bottom: 5px;
        }
        .col-resume{
            display: block;
        }

        .col-resume-2{
            display: none;
        }

        .col-60, .col-40 {
            flex-basis: 100%;
            max-width: 100%;
        }

        .footer-block{
            display: block;
        }

        .col-40 {
            border: none;
            display: none;
        }

        .logo-block{
            display: none;
        }

        .row-single{
            display: block;
        }

        .logo-none{
            display: none;
        }
    }

    .line-through {
        text-decoration: line-through;
    }
    </style>